import React from "react";
import "../../css/carousels.css";

function SlideThree({ size }) {
  return (
    <div style={size}>
      <svg
        id="Floor_3"
        data-name="Floor 3"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 1000 795"
        style={{ width: "100%", maxWidth: "1000px" }}
      >
        <rect class="threeCls-10" width="1000" height="795" />
        <polygon
          class="threeCls-14"
          points="424.05 2.39 428.25 3.03 432.18 4.23 435.54 6.49 438.51 9.21 440.48 12.72 442.1 16.47 442.27 20.68 441.97 24.86 440.48 28.64 438.48 32.13 435.45 34.76 432.17 37.09 428.25 38.35 424.05 38.96 419.85 38.32 415.93 37.09 412.56 34.86 409.63 32.11 407.53 28.68 406.05 24.87 405.7 20.68 405.97 16.47 407.55 12.69 409.69 9.29 412.61 6.57 415.94 4.3 419.87 3.13 424.05 2.39 424.05 2.39"
        />
        <g>
          <polygon
            class="threeCls-10"
            points="517.98 736.77 516.84 740.71 461.7 742.18 461.7 693.07 539.3 693.07 539.3 733.32 517.98 736.77"
          />
          <polygon
            class="threeCls-10"
            points="539.08 788.87 461.26 788.87 461.26 743.13 515.14 744.09 516.68 745.59 529.36 745.05 530.92 744.37 539.08 744.51 539.08 788.87"
          />
        </g>
        <g>
          <polygon
            class="threeCls-10"
            points="461.69 692.43 461.86 789.39 290.91 789.39 267.4 791.51 261.12 789.39 250.49 789.39 251.25 757.25 249.92 725.02 251.69 692.58 250.25 663.02 251.25 627.58 249.37 594.02 250.49 562.7 540.03 562.93 540 649.47 537.67 678.02 539.37 692.43 461.69 692.43"
          />
          <path
            class="threeCls-2"
            d="M462.29,789.56l-20.48-.65-20.03,2.07-20.23-1.99-20.04,1.23-20.21-1.02-20.06,1.49-20.2-1.35-29.24,1.11-14.13,1.08-14.05.09-6.89-2.22-7.1.77,1.7-32.48-2.17-32.43,2.33-32.43-1.89-32.43,1.65-32.43-3.13-32.43,1.97-32.17,41.16-1,41.66,1,41.48-1.64,41.72,2.26,41.52-1.75,63.97.56M539.1,693.06l-1.8-14.08,2.59-14.27-.51-14.27,1.45-14.27-1.8-14.27,2.56-14.27-2.59-43.19"
          />
        </g>
        <g>
          <polygon
            class="threeCls-10"
            points="547.78 235.86 576.78 236.74 605.17 235.58 633.55 236.37 661.94 235.41 690.33 236.96 718.71 235.35 745.98 237.06 747.27 263.88 746.14 291.48 748.04 319.07 745.64 346.67 747.73 374.27 746.6 401.86 747.66 429.85 718.71 428.91 690.33 429.88 661.94 429.24 633.55 429.99 605.17 429.37 576.78 430.03 548.7 429.25 546.8 401.86 548.72 374.27 548.33 346.67 549.46 319.07 548.08 291.48 550.05 263.88 547.78 235.86 547.78 235.86"
          />
          <polygon
            class="threeCls-2"
            points="547.78 235.86 576.78 236.74 605.17 235.58 633.55 236.37 661.94 235.41 690.33 236.96 718.71 235.35 745.98 237.06 747.27 263.88 746.14 291.48 748.04 319.07 745.64 346.67 747.73 374.27 746.6 401.86 747.66 429.85 718.71 428.91 690.33 429.88 661.94 429.24 633.55 429.99 605.17 429.37 576.78 430.03 548.7 429.25 546.8 401.86 548.72 374.27 548.33 346.67 549.46 319.07 548.08 291.48 550.05 263.88 547.78 235.86 547.78 235.86"
          />
        </g>
        <g>
          <polygon
            class="threeCls-10"
            points="370.29 163.93 346.09 165.46 322.14 163.42 294.7 163.93 256.36 162.93 201.76 162.31 200.86 17.38 371.13 17.86 369.7 53.56 371.92 97.86 370.29 139.04 370.29 163.93"
          />
          <polyline
            class="threeCls-2"
            points="202.18 163.4 201.17 143.11 202.06 122.2 200.56 101.3 202.45 80.4 200.8 59.5 201.7 38.59 200.86 17.38 225.6 18.12 249.89 17.35 274.19 17.86 298.48 17.27 322.78 17.76 347.08 17.24 371.13 17.86"
          />
        </g>
        <path
          class="threeCls-9"
          d="M594,596.04h-.7s-.06-.03-.06-.06v-.44s.02-.06.06-.06h.7s.06.02.06.06v.44s-.03.06-.06.06h0Z"
        />
        <path
          class="threeCls-9"
          d="M594,596.04h-.7s-.06-.03-.06-.06v-.44s.02-.06.06-.06h.7s.06.02.06.06v.44s-.03.06-.06.06h0Z"
        />
        <line class="threeCls-4" x1="995" y1="162.78" x2="995" y2="211.7" />
        <g id="Jharokhe">
          <polygon
            class="threeCls-10"
            points="796 598.53 817.74 599.19 839.02 598.32 860.3 598.91 881.58 598.19 902.87 599.35 924.15 598.15 944.6 599.43 945.55 619.4 944.71 639.94 946.13 660.49 944.34 681.04 945.9 701.59 945.06 722.13 945.85 742.98 924.15 742.27 902.87 743 881.58 742.52 860.3 743.08 839.02 742.62 817.74 743.11 796.68 742.53 795.26 722.13 796.7 701.59 796.41 681.04 797.25 660.49 796.22 639.94 797.69 619.4 796 598.53 796 598.53"
          />
          <g>
            <polygon
              class="threeCls-8"
              points="796 598.53 817.74 599.19 839.02 598.32 860.3 598.91 881.58 598.19 902.87 599.35 924.15 598.15 944.6 599.43 945.55 619.4 944.71 639.94 946.13 660.49 944.34 681.04 945.9 701.59 945.06 722.13 945.85 742.98 924.15 742.27 902.87 743 881.58 742.52 860.3 743.08 839.02 742.62 817.74 743.11 796.68 742.53 795.26 722.13 796.7 701.59 796.41 681.04 797.25 660.49 796.22 639.94 797.69 619.4 796 598.53 796 598.53"
            />
            <g>
              <path
                class="threeCls-9"
                d="M841.69,675.94c.28.13.9.32,1.69.32,1.75,0,2.45-1.01,2.45-2.31v-8.11h-1.15v8.08c0,.89-.35,1.28-1.23,1.28-.61,0-1.07-.15-1.39-.33l-.38,1.06h0Z"
              />
              <path
                class="threeCls-9"
                d="M851.92,668c-1.34,0-2.06.73-2.29,1.01h-.06v-4.01h-1.14v11.07h1.14v-5.66c.28-.69,1.02-1.4,2.12-1.4s1.6.76,1.6,1.75v5.31h1.14v-5.49c0-1.62-.98-2.58-2.51-2.58h0Z"
              />
              <path
                class="threeCls-9"
                d="M860.9,674.22c-.36.54-1.08,1.08-1.98,1.08s-1.43-.57-1.43-1.27c0-1.2,1.5-1.66,3.41-1.59v1.78h0ZM859.26,668.02c-1.65,0-2.39.92-2.67,1.3l.83.66c.23-.38.74-.96,1.81-.96s1.68.38,1.68,1.68v.86c-2.82-.04-4.54.82-4.54,2.57,0,1.08.82,2.12,2.29,2.12,1.34,0,1.98-.63,2.36-1.07h.06c.19.54.66.96,1.44.96.15,0,.31-.03.41-.09v-.83h-.2c-.55,0-.77-.48-.77-1.2v-3.59c0-1.66-1.01-2.41-2.7-2.41h0Z"
              />
              <path
                class="threeCls-9"
                d="M868.72,668.08c-.18-.04-.44-.07-.8-.07-.92,0-1.65.44-2,1.01h-.06l-.25-.88h-.86v7.94h1.12v-5.91c.38-.71,1.18-1.02,1.96-1.02.29,0,.6.03.89.12v-1.18h0Z"
              />
              <path
                class="threeCls-9"
                d="M870.77,672.03c0-2.06.57-3.06,2.07-3.06s2.17,1.04,2.17,3.17-.56,3.08-2.09,3.08-2.16-1.05-2.16-3.18h0ZM872.84,676.2c2.41,0,3.34-1.71,3.34-4.16s-.83-4.06-3.25-4.06-3.33,1.68-3.33,4.13.83,4.09,3.24,4.09h0Z"
              />
              <path
                class="threeCls-9"
                d="M879.32,665h-1.14v11.07h1.14v-11.07h0ZM879.53,672l2.99,4.07h1.45l-3.11-4.1v-.06l2.93-3.78h-1.42l-2.85,3.81v.06h0Z"
              />
              <path
                class="threeCls-9"
                d="M888.97,668c-1.34,0-2.06.73-2.29,1.01h-.06v-4.01h-1.14v11.07h1.14v-5.66c.28-.69,1.02-1.4,2.12-1.4s1.6.76,1.6,1.75v5.31h1.14v-5.49c0-1.62-.98-2.58-2.51-2.58h0Z"
              />
              <path
                class="threeCls-9"
                d="M898.91,674.58c-.34.29-1.05.6-1.84.6-1.59,0-2.41-.74-2.51-2.7h5.05c.06-.51.09-.98.09-1.37,0-1.88-1.01-3.11-2.89-3.11-1.77,0-3.37,1.18-3.37,4.06s1.23,4.11,3.49,4.11c1.14,0,1.97-.32,2.49-.71l-.51-.88h0ZM896.71,668.98c1.28,0,1.87.76,1.87,2.12,0,.1,0,.28-.01.45h-3.98c.1-1.91,1.09-2.57,2.13-2.57h0Z"
              />
            </g>
          </g>
        </g>
        <g id="Adventure_adda" data-name="Adventure adda">
          <g>
            <path
              class="threeCls-9"
              d="M635.12,95.44c.22-.71.41-1.33.58-1.94h.06c.19.63.36,1.23.6,1.97l1.09,3.44h-3.44l1.11-3.47h0ZM634.84,92.7l-3.31,10.23h1.2l.95-2.98h4.11l.95,2.98h1.22l-3.31-10.23h-1.81Z"
            />
            <path
              class="threeCls-9"
              d="M645.87,95.12c-.36-.07-.8-.13-1.27-.13-2.23,0-3.76,1.44-3.76,4.32,0,2.6,1.14,3.78,2.93,3.78,1.04,0,1.77-.5,2.07-.96h.06l.25.8h.85v-11.07h-1.12v3.27h0ZM644.02,102.11c-1.05,0-2.03-.71-2.03-2.93s.92-3.2,2.67-3.2c.36,0,.9.09,1.21.19v4.65c-.31.74-.9,1.28-1.85,1.28h0Z"
            />
            <path
              class="threeCls-9"
              d="M649.61,94.99h-1.24l2.73,7.94h1.31l2.68-7.94h-1.18l-1.52,4.76c-.23.76-.44,1.42-.6,2.09h-.06c-.16-.67-.34-1.33-.58-2.09l-1.55-4.76h0Z"
            />
            <path
              class="threeCls-9"
              d="M661.51,101.44c-.34.29-1.05.6-1.84.6-1.59,0-2.41-.74-2.51-2.7h5.05c.06-.51.09-.98.09-1.37,0-1.88-1.01-3.11-2.89-3.11-1.77,0-3.37,1.18-3.37,4.06s1.23,4.11,3.49,4.11c1.14,0,1.97-.32,2.49-.71l-.51-.88h0ZM659.31,95.84c1.28,0,1.87.76,1.87,2.12,0,.1,0,.28-.01.45h-3.98c.1-1.91,1.09-2.57,2.13-2.57h0Z"
            />
            <path
              class="threeCls-9"
              d="M670.39,97.46c-.04-1.77-.99-2.63-2.58-2.63-1.24,0-2.04.72-2.26.99h-.06l-.23-.83h-.86v7.94h1.14v-5.68c.28-.77,1.04-1.42,2.01-1.42,1.11,0,1.71.67,1.71,1.88v5.21h1.14v-5.47h0Z"
            />
            <path
              class="threeCls-9"
              d="M675.04,103c.95,0,1.47-.19,1.78-.36l-.32-.9c-.2.13-.57.28-1.21.28-.7,0-1.15-.36-1.15-1.25v-4.84h2.19v-.92h-2.19v-2.09h-.77l-.35,2.06-1.18.22v.73h1.18v4.9c0,1.5.71,2.19,2.03,2.19h0Z"
            />
            <path
              class="threeCls-9"
              d="M678.28,100.42c.04,1.81.95,2.67,2.58,2.67,1.33,0,2.04-.69,2.26-.99h.06l.22.83h.89v-7.94h-1.14v5.21c-.03,1.25-.86,1.91-2,1.91s-1.74-.63-1.74-1.93v-5.19h-1.14v5.43h0Z"
            />
            <path
              class="threeCls-9"
              d="M690.68,94.93c-.18-.04-.44-.07-.8-.07-.92,0-1.65.44-2,1.01h-.06l-.25-.88h-.86v7.94h1.12v-5.91c.38-.71,1.18-1.02,1.96-1.02.29,0,.6.03.89.12v-1.18h0Z"
            />
            <path
              class="threeCls-9"
              d="M697.02,101.44c-.34.29-1.05.6-1.84.6-1.59,0-2.41-.74-2.51-2.7h5.05c.06-.51.09-.98.09-1.37,0-1.88-1.01-3.11-2.89-3.11-1.76,0-3.37,1.18-3.37,4.06s1.23,4.11,3.49,4.11c1.14,0,1.97-.32,2.49-.71l-.51-.88h0ZM694.82,95.84c1.28,0,1.87.76,1.87,2.12,0,.1,0,.28-.01.45h-3.98c.1-1.91,1.09-2.57,2.13-2.57h0Z"
            />
            <path
              class="threeCls-9"
              d="M717.35,95.12c-.36-.07-.8-.13-1.27-.13-2.23,0-3.76,1.44-3.76,4.32,0,2.6,1.14,3.78,2.93,3.78,1.04,0,1.77-.5,2.07-.96h.06l.25.8h.85v-11.07h-1.12v3.27h0ZM715.5,102.11c-1.05,0-2.03-.71-2.03-2.93s.92-3.2,2.67-3.2c.36,0,.9.09,1.21.19v4.65c-.31.74-.9,1.28-1.85,1.28h0Z"
            />
            <path
              class="threeCls-9"
              d="M725.5,95.12c-.36-.07-.8-.13-1.27-.13-2.23,0-3.76,1.44-3.76,4.32,0,2.6,1.14,3.78,2.93,3.78,1.04,0,1.77-.5,2.07-.96h.06l.25.8h.85v-11.07h-1.12v3.27h0ZM723.65,102.11c-1.05,0-2.03-.71-2.03-2.93s.92-3.2,2.67-3.2c.36,0,.9.09,1.21.19v4.65c-.31.74-.9,1.28-1.85,1.28h0Z"
            />
            <path
              class="threeCls-9"
              d="M733.15,101.08c-.36.54-1.08,1.08-1.98,1.08s-1.43-.57-1.43-1.27c0-1.2,1.5-1.66,3.41-1.59v1.78h0ZM731.5,94.87c-1.65,0-2.39.92-2.67,1.3l.83.66c.23-.38.74-.96,1.81-.96s1.68.38,1.68,1.68v.86c-2.82-.04-4.54.82-4.54,2.57,0,1.08.82,2.12,2.29,2.12,1.34,0,1.98-.63,2.36-1.07h.06c.19.54.66.96,1.44.96.15,0,.31-.03.41-.09v-.83h-.2c-.55,0-.77-.48-.77-1.2v-3.59c0-1.66-1.01-2.41-2.7-2.41h0Z"
            />
            <path
              class="threeCls-9"
              d="M709.43,101.08c-.36.54-1.08,1.08-1.98,1.08s-1.43-.57-1.43-1.27c0-1.2,1.5-1.66,3.41-1.59v1.78h0ZM707.78,94.87c-1.65,0-2.39.92-2.67,1.3l.83.66c.23-.38.74-.96,1.81-.96s1.68.38,1.68,1.68v.86c-2.82-.04-4.54.82-4.54,2.57,0,1.08.82,2.12,2.29,2.12,1.34,0,1.98-.63,2.36-1.07h.06c.19.54.66.96,1.44.96.15,0,.31-.03.41-.09v-.83h-.2c-.55,0-.77-.48-.77-1.2v-3.59c0-1.66-1.01-2.41-2.7-2.41h0Z"
            />
          </g>
          <path
            class="threeCls-16"
            d="M685.32,56.22c.21,5.22.15,10.59.09,15.79-.19-.1-.44-.1-.67-.1-.07,0-.13,0-.2,0-.28,0-.56-.01-.84-.01h-.17c-.36,0-2.19,0-2.51,0h-.1c-.07,0-.2,0-.35.05,0-1.39.04-3,.07-4.56v-.04c.03-1.1.05-2.15.06-3.06.02-1.17.1-5.11.05-6.53l-.02-1.06c0-.11,0-.24,0-.38,0-.06,0-.13-.01-.2.21,0,.43,0,.64,0,1.29,0,2.61.02,3.96.05,0,.03,0,.06,0,.08h0ZM685.09,73.52c-.58,0-1.17-.02-1.74-.04-.57-.02-1.17-.04-1.76-.04-.47,0-.88.01-1.24.04h-.04c-.05,0-.12,0-.2,0,.07-.07.23-.23.23-.23.18-.19.37-.38.48-.5.02,0,.08-.01.2-.01.07,0,.15,0,.23,0,.07,0,.14,0,.2,0,.04,0,.08,0,.1,0h2.17c.38,0,.82,0,1.33-.03.05,0,.06,0,.15.1.07.07.15.15.23.23.15.15.31.3.45.46-.24,0-.5.01-.78.01h0ZM694.68,78.95c-.08-.13-.2-.23-.36-.27-.3-.06-.62-.1-.97-.12.04-2.18.03-4.56-.05-7.41l-.05-1.56c-.05-1.6-.11-3.58-.15-4.51-.04-.71-.16-1.93-.27-3.12-.11-1.11-.22-2.25-.26-2.95l-.23-2.5c.01-.53-.45-1.18-1.07-1.26-.17-.02-.28-.02-.39-.03-.05,0-.11,0-.17,0-2.84-.11-5.6-.16-8.22-.16-2.94,0-5.82.07-8.56.21h-.03s-.03.01-.03.01c-.78.23-.78,1.02-.78,1.55,0,.1,0,.19,0,.29l-.02,2.02c-.03,1.41.08,2.84.19,4.22.1,1.27.2,2.57.19,3.86.02,2.03-.05,4.82-.1,7.07l-.02.99-.04,2.03c0,.19,0,.41-.01.65,0,.21-.02.42-.02.63-.28,0-.54.02-.79.06-.24.02-.43.2-.49.43-.03.14,0,.29.07.42.08.13.2.21.35.25.52.11,1.06.16,1.67.16.41,0,.84-.02,1.32-.08.28-.03.49-.26.48-.56,0-.29-.21-.52-.49-.54-.14-.01-.28-.03-.42-.04h-.04c-.09-.01-.19-.02-.28-.03,0-.08,0-.15,0-.23v-.11c0-.29,0-.85.01-1.42v-.09c0-.6.01-1.21.01-1.52,0-.93.01-1.85.02-2.83.04-3.13.08-6.36-.27-9.34-.2-1.99-.29-4.11-.27-6.49,0-.06,0-.12,0-.18,0-.05,0-.12,0-.14h0s0-.02,0-.02c.02-.01.14-.02.19-.02.06,0,.13,0,.19,0,1.65-.08,3.37-.13,5.12-.15,0,.02,0,.04,0,.05.19,4.74.13,9.72.07,14.53v.1c0,.64-.02,1.28-.02,1.91l-.15.16c-.05.05-.14.14-.24.25-.11.11-.23.23-.27.28-.17.17-.23.38-.15.58.1.24.37.41.65.41.02,0,.04,0,.06,0,.52.04,1.07.05,1.7.05s1.25-.02,1.87-.03c.6-.02,1.22-.03,1.84-.03.48,0,.92.01,1.35.03.29,0,.57-.2.64-.46.07-.23-.04-.47-.25-.6-.18-.13-.33-.28-.48-.45-.02-1.68.02-3.89.05-5.85v-.03c.02-.95.03-1.86.04-2.65.02-1.17.1-5.1.05-6.53l-.03-1.06c0-.11,0-.24,0-.38,0-.06,0-.12-.01-.19,1.39.04,2.81.1,4.29.18.04,0,.07,0,.11,0q.41,0,.44.68v.07s.14,2.02.14,2.02c.36,3.92.43,7.95.49,11.86.04,2.5.09,5.09.21,7.62-.15.01-.3.02-.45.04-.15.01-.31.03-.46.04-.29.02-.5.25-.5.55,0,.25.17.52.5.55.14,0,.28.02.41.03h.05c.47.04.95.09,1.43.09s.9-.04,1.3-.13c.19-.05.34-.2.39-.39.04-.14.02-.3-.05-.43h0Z"
          />
        </g>

        <g id="Signage_list" data-name="Signage list">
          <polygon
            class="threeCls-9"
            points="23.06 49.99 15.72 49.99 16.71 53.56 9.05 53.56 10.04 57.13 1.97 57.13 1.97 59.14 13.19 59.14 12.2 55.58 19.86 55.58 18.87 52.01 23.63 52.01 23.06 49.99 23.06 49.99"
          />
          <g>
            <path
              class="threeCls-9"
              d="M3.42,46.24c-.49,0-.89-.39-.9-.89l-.05-3.46c0-.26.11-.51.3-.68l2.37-2.13c.19-.17.44-.25.7-.23l2.09.22,1.63-.21c.36-.05.72.13.9.45l1.74,3.08,1.85-1.13c.42-.26.98-.13,1.24.3.26.42.13.98-.3,1.24l-2.65,1.62c-.21.13-.46.17-.7.1-.24-.06-.44-.22-.56-.43l-1.9-3.37-1.13.14c-.07,0-.14,0-.21,0l-1.8-.19-1.77,1.59.05,3.05c0,.5-.39.91-.89.91h-.01Z"
            />
            <path
              class="threeCls-9"
              d="M9.69,36.35c0,1.12-.91,2.02-2.02,2.02s-2.02-.91-2.02-2.02.91-2.02,2.02-2.02,2.02.91,2.02,2.02h0Z"
            />
            <path
              class="threeCls-9"
              d="M5.09,57.46c-.05,0-.1,0-.16-.01-.56-.09-.95-.61-.86-1.18l1.54-10.07c.05-.3.22-.57.48-.72.26-.16.58-.19.87-.1l6.1,2.04c.47.16.76.62.7,1.11l-.54,4.09c-.07.56-.59.96-1.16.89-.56-.07-.96-.59-.89-1.16l.43-3.25-4.13-1.38-1.35,8.86c-.08.51-.52.88-1.02.88h0Z"
            />
            <path
              class="threeCls-9"
              d="M9.78,47.92h-4.2c-.1,0-.18-.08-.18-.18v-8.69c0-.1.08-.18.18-.18h4.2c.1,0,.19.08.19.18v8.69c0,.1-.08.18-.19.18h0Z"
            />
            <path
              class="threeCls-9"
              d="M50.99,46.53c-1.47,0-2.45-.6-3.13-1.16l-.82,1.12c.7.63,1.98,1.3,3.83,1.3,2.63,0,4.1-1.54,4.1-3.4,0-3.78-5.85-3.19-5.85-6.02,0-1.12.86-1.93,2.29-1.93,1.03,0,1.79.35,2.4.84l.86-1.09c-.7-.58-1.79-1.03-3.17-1.03-2.21,0-3.8,1.44-3.8,3.29,0,3.87,5.85,3.24,5.85,6.02,0,1.14-.89,2.05-2.56,2.05h0Z"
            />
            <path
              class="threeCls-9"
              d="M60.01,47.71c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
            <path
              class="threeCls-9"
              d="M68.87,45.39c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM66.89,37.95c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="threeCls-9"
              d="M73.95,47.62h1.37v-9.52h-1.37v9.52h0ZM73.56,35.33c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="threeCls-9"
              d="M83.31,38.02c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="threeCls-9"
              d="M89.21,45.1c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
          </g>
          <g>
            <path
              class="threeCls-9"
              d="M25.84,18.97c-.1-.1-.26-.1-.36,0l-.76.76v-2.88c0-.14-.11-.25-.26-.25s-.25.11-.25.25v2.88l-.76-.76c-.1-.1-.26-.1-.36,0-.1.1-.1.26,0,.36l1.16,1.16s.06.05.1.06c.03.01.07.02.11.02s.07,0,.11-.02c.04-.01.07-.03.1-.06l1.16-1.16c.1-.1.1-.26,0-.36h0Z"
            />
            <path
              class="threeCls-9"
              d="M25.84,13.08l-1.16-1.16s-.06-.05-.1-.06c-.03-.01-.07-.02-.11-.02s-.07,0-.11.02c-.04.01-.07.03-.1.06l-1.16,1.16c-.1.1-.1.26,0,.36.05.05.12.08.18.08s.13-.02.18-.08l.76-.75v2.87c0,.14.11.26.25.26s.26-.11.26-.26v-2.88l.76.76c.05.05.11.08.18.08s.13-.02.18-.08c.1-.1.1-.26,0-.36h0Z"
            />
            <path
              class="threeCls-9"
              d="M3.6,4.74c-.38,0-.7.31-.7.7v21.55c0,.38.31.7.7.7h16.2c.38,0,.7-.31.7-.7V5.43c0-.38-.31-.7-.7-.7H3.6ZM19.8,28.61H3.6c-.9,0-1.63-.73-1.63-1.63V5.43c0-.9.73-1.63,1.63-1.63h16.2c.9,0,1.63.73,1.63,1.63v21.55c0,.9-.73,1.63-1.63,1.63h0Z"
            />
            <path
              class="threeCls-9"
              d="M13.49,9.22c0,.99-.8,1.79-1.79,1.79s-1.79-.8-1.79-1.79.8-1.79,1.79-1.79,1.79.8,1.79,1.79h0Z"
            />
            <path
              class="threeCls-9"
              d="M13.87,11.51h-4.34c-.74,0-1.34.51-1.34,1.14v5.36c0,.34.32.61.72.61s.72-.27.72-.61v-5.28h.37v14.09c0,.34.32.61.72.61s.72-.27.72-.61v-7.76h.5v7.76c0,.34.32.61.72.61s.72-.27.72-.61v-8.55s0-5.54,0-5.54h.37v5.28c0,.34.32.61.72.61s.72-.27.72-.61v-5.37c0-.63-.6-1.14-1.34-1.14h0Z"
            />
            <polygon
              class="threeCls-9"
              points="47.22 4.97 47.22 17.25 53.89 17.25 53.89 16 48.62 16 48.62 4.97 47.22 4.97 47.22 4.97"
            />
            <path
              class="threeCls-9"
              d="M56.08,17.25h1.37V7.72h-1.37v9.52h0ZM55.7,4.96c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="threeCls-9"
              d="M65.5,4.01c-.37-.12-.81-.21-1.47-.21-1.86,0-2.71,1.01-2.71,2.49v1.44h-1.59v1.07h1.58v8.46h1.37v-8.46h2.49v-1.07h-2.47v-1.45c0-.86.35-1.28,1.26-1.28.54,0,.93.05,1.28.18l.28-1.16h0Z"
            />
            <path
              class="threeCls-9"
              d="M69.7,17.33c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
          </g>
          <g>
            <path
              class="threeCls-9"
              d="M12.8,77.74c-.23,0-.44.07-.61.18-.68.44-.52,1.5.24,1.79l.15.06c1.76.66,3.62,1,5.49,1h2.47c.47,0,.85-.38.85-.85v-1.51c0-.38-.31-.69-.69-.69l-7.92.03h0Z"
            />
            <path
              class="threeCls-9"
              d="M14.71,72.22c0,1.42-1.15,2.57-2.57,2.57s-2.58-1.15-2.58-2.57,1.15-2.58,2.58-2.58,2.57,1.15,2.57,2.58h0Z"
            />
            <path
              class="threeCls-9"
              d="M13.42,81.73l-3.52-2.37v-4.21c0-.23-.07-.44-.18-.62-.11-.23-.27-.44-.48-.6-.73-.57-1.78-.44-2.34.29l-4.58,5.88c-.06.08-.11.16-.16.25-.12.2-.19.43-.19.68v12.11c0,.73.59,1.31,1.31,1.31s1.31-.59,1.31-1.31v-10.66c.13-.09.26-.2.36-.34l2.66-3.41v1.23c0,.38.19.74.51.95l4.02,2.71c.2.13.42.2.64.2.37,0,.73-.18.95-.51.35-.53.22-1.24-.31-1.59h0Z"
            />
            <path
              class="threeCls-9"
              d="M19.91,77.98h-.7s-.06-.03-.06-.06v-.44s.03-.06.06-.06h.7s.06.03.06.06v.44s-.03.06-.06.06h0Z"
            />
            <path
              class="threeCls-9"
              d="M17.3,74.52h0c-.17-.07-.26-.26-.19-.43.07-.17.26-.26.43-.19.17.07.26.26.19.43-.05.13-.18.21-.31.21-.04,0-.08,0-.12-.02h0ZM16.23,74.78c-.14-.12-.16-.33-.04-.47.12-.14.33-.16.47-.04.14.12.16.33.04.47-.07.08-.16.12-.26.12-.08,0-.15-.03-.21-.08h0ZM18,75.13h0c-.12-.14-.09-.35.05-.47.14-.12.35-.09.47.05h0c.11.14.09.35-.05.47-.06.05-.13.07-.21.07-.1,0-.2-.04-.26-.12h0ZM15.63,75.72c-.16-.1-.21-.3-.11-.46.1-.16.31-.2.46-.11.16.1.2.31.11.46-.06.1-.17.16-.29.16-.06,0-.12-.02-.18-.05h0ZM18.59,76.01c-.09-.16-.04-.36.12-.46.16-.09.36-.04.46.12.09.16.04.36-.12.45-.05.03-.11.04-.17.04-.12,0-.23-.06-.29-.17h0ZM15.1,76.69c-.16-.09-.22-.29-.14-.45.09-.16.29-.22.45-.14.16.09.22.29.14.45-.06.11-.18.18-.3.18-.05,0-.11-.01-.16-.04h0ZM19.1,76.98h0c-.08-.16-.02-.37.15-.45.16-.08.36-.01.45.15.08.16.02.36-.15.45-.05.02-.1.04-.15.04-.12,0-.24-.07-.3-.19h0Z"
            />
            <path
              class="threeCls-9"
              d="M12.8,77.74c-.23,0-.44.07-.61.18-.68.44-.52,1.5.24,1.79l.15.06c1.76.66,3.62,1,5.49,1h2.47c.47,0,.85-.38.85-.85v-1.51c0-.38-.31-.69-.69-.69l-7.92.03h0Z"
            />
            <path
              class="threeCls-9"
              d="M14.71,72.22c0,1.42-1.15,2.57-2.57,2.57s-2.58-1.15-2.58-2.57,1.15-2.58,2.58-2.58,2.57,1.15,2.57,2.58h0Z"
            />
            <path
              class="threeCls-9"
              d="M13.42,81.73l-3.52-2.37v-4.21c0-.23-.07-.44-.18-.62-.11-.23-.27-.44-.48-.6-.73-.57-1.78-.44-2.34.29l-4.58,5.88c-.06.08-.11.16-.16.25-.12.2-.19.43-.19.68v12.11c0,.73.59,1.31,1.31,1.31s1.31-.59,1.31-1.31v-10.66c.13-.09.26-.2.36-.34l2.66-3.41v1.23c0,.38.19.74.51.95l4.02,2.71c.2.13.42.2.64.2.37,0,.73-.18.95-.51.35-.53.22-1.24-.31-1.59h0Z"
            />
            <path
              class="threeCls-9"
              d="M19.91,77.98h-.7s-.06-.03-.06-.06v-.44s.03-.06.06-.06h.7s.06.03.06.06v.44s-.03.06-.06.06h0Z"
            />
            <path
              class="threeCls-9"
              d="M17.3,74.52h0c-.17-.07-.26-.26-.19-.43.07-.17.26-.26.43-.19.17.07.26.26.19.43-.05.13-.18.21-.31.21-.04,0-.08,0-.12-.02h0ZM16.23,74.78c-.14-.12-.16-.33-.04-.47.12-.14.33-.16.47-.04.14.12.16.33.04.47-.07.08-.16.12-.26.12-.08,0-.15-.03-.21-.08h0ZM18,75.13h0c-.12-.14-.09-.35.05-.47.14-.12.35-.09.47.05h0c.11.14.09.35-.05.47-.06.05-.13.07-.21.07-.1,0-.2-.04-.26-.12h0ZM15.63,75.72c-.16-.1-.21-.3-.11-.46.1-.16.31-.2.46-.11.16.1.2.31.11.46-.06.1-.17.16-.29.16-.06,0-.12-.02-.18-.05h0ZM18.59,76.01c-.09-.16-.04-.36.12-.46.16-.09.36-.04.46.12.09.16.04.36-.12.45-.05.03-.11.04-.17.04-.12,0-.23-.06-.29-.17h0ZM15.1,76.69c-.16-.09-.22-.29-.14-.45.09-.16.29-.22.45-.14.16.09.22.29.14.45-.06.11-.18.18-.3.18-.05,0-.11-.01-.16-.04h0ZM19.1,76.98h0c-.08-.16-.02-.37.15-.45.16-.08.36-.01.45.15.08.16.02.36-.15.45-.05.02-.1.04-.15.04-.12,0-.24-.07-.3-.19h0Z"
            />
            <path
              class="threeCls-9"
              d="M47.22,78.09h3.2c3.76,0,5.38-2.26,5.38-6.25s-1.66-6.02-5.36-6.02h-3.22v12.27h0ZM48.62,67.06h1.7c2.61,0,4.04,1.28,4.04,4.94s-1.26,4.85-3.96,4.85h-1.79v-9.79h0Z"
            />
            <path
              class="threeCls-9"
              d="M63.08,68.5c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="threeCls-9"
              d="M65.1,78.09h1.37v-9.52h-1.37v9.52h0ZM64.71,65.8c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="threeCls-9"
              d="M76.9,71.53c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="threeCls-9"
              d="M81.12,64.81h-1.37v13.29h1.37v-13.29h0ZM81.38,73.21l3.59,4.88h1.73l-3.73-4.92v-.07l3.52-4.53h-1.7l-3.41,4.57v.07h0Z"
            />
            <path
              class="threeCls-9"
              d="M88.98,78.09h1.37v-9.52h-1.37v9.52h0ZM88.59,65.8c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="threeCls-9"
              d="M100.78,71.53c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="threeCls-9"
              d="M110.48,68.97c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.09,0,3.24,1.66,4.46,3.62,4.46,1.22,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM109.13,69.94v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.11,1.56.26h0Z"
            />
            <path
              class="threeCls-9"
              d="M52.26,90.98l1.94,8.12h1.84l2.56-9.52h-1.31l-1.35,5.23c-.26,1-.51,2.05-.74,3.08h-.07c-.19-.96-.4-1.82-.61-2.7l-1.4-5.62h-1.75l-1.43,5.62c-.23.88-.42,1.77-.61,2.7h-.07c-.21-1.05-.45-2.05-.72-3.06l-1.33-5.25h-1.4l2.52,9.52h1.84l2.03-8.12h.07Z"
            />
            <path
              class="threeCls-9"
              d="M65.18,96.88c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM63.21,89.44c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.1v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="threeCls-9"
              d="M72.54,99.19c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
            <path
              class="threeCls-9"
              d="M82.54,97.32c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM79.89,90.59c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="threeCls-9"
              d="M90.75,89.51c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.23,2.35-1.23.35,0,.72.03,1.07.14v-1.42h0Z"
            />
          </g>
          <g>
            <path
              class="threeCls-15"
              d="M18.66,356.17v2.97c0,.28.38.42.69.38.4-.05.41-.27.41-.66v-1.07c0-.57.06-1.8-.13-2.21-.11-.22-.36-.51-.55-.62-.4-.23-1.56-.24-2.11-.24-.87,0-1.57.06-2.1.54-.23.21-.31.48-.35.9-.04.41-.05,2.39-.03,3,.02.42.55.42.78.33.17-.07.21-.15.21-.37v-2.8s.22.01.22.01c.02,2.5.04,5,.05,7.5,0,.28-.05.65.11.84.26.3.82.18,1.04-.05.09-.1.09-.21.09-.38l.04-3.73c0-.78-.06-.72.2-.69v4.32c.02.25-.02.52.14.65.15.12.42.13.63.06.51-.16.49-.6.48-1.05-.02-2.16-.02-3.81,0-5.91,0-.29,0-.57.01-.85,0-.1,0-.71.02-.81v-.04s.15,0,.15,0h0Z"
            />
            <path
              class="threeCls-15"
              d="M9.91,356.19c.25-.05.21.03.21.23.02,2.66.02,4.65,0,7.31,0,.54,0,.85.38,1.05.22.11.86.22.86-.36v-4.62s.21,0,.21,0c0,1.23.02,2.46.03,3.69,0,.27-.02.67.01.93.02.21.3.36.54.4.31.05.55-.06.65-.27.09-.18.05-.65.05-.88.02-2.46.04-4.92.05-7.37h.21s0,2.82,0,2.82c0,.46.54.43.74.36.15-.06.25-.13.25-.33.02-.63.01-2.51-.02-2.96-.03-.43-.11-.71-.34-.93-.46-.44-1.15-.55-1.99-.55-.58,0-1.82,0-2.24.25-.18.11-.45.42-.55.65-.13.29-.12.73-.12,1.07v1.66c0,.69-.11,1.13.4,1.2.17.03.32,0,.45-.08.18-.1.18-.21.18-.42,0-.63-.03-2.32.02-2.83,0,0,0-.01,0-.02h0Z"
            />
            <path
              class="threeCls-15"
              d="M23.5,365.22c.52,0,2.84.06,3.13-.13-.04-.21-1.1-1.23-1.34-1.47-.16-.15-.3-.31-.47-.47l-4.58.1c-.04.67-.03,1.4-.04,2.07-.01.69-.03,1.38-.04,2.07,0,.1-.02.44,0,.5.02.07,1.19,1.17,1.33,1.3.09.09.45.43.59.45.21-.3.1-2.43.14-2.96.08.05.33.31.41.4l1.99,1.98c.15.14.67.7.82.76l.7-.61c.11-.12.57-.56.68-.63-.04-.1-.33-.36-.42-.45l-2.89-2.92h0Z"
            />
            <path
              class="threeCls-15"
              d="M8.53,363.17c-.18-.03-3.93,0-4.22,0-.09,0-.2,0-.28,0-.12,0-.3.23-.43.36-.31.3-1.38,1.31-1.55,1.61.27.12,2.59.15,3.08.17-.03.07,0,.02-.05.08l-2.73,2.69c-.12.12-.28.26-.38.38.11.12.22.23.33.35.11.11.21.24.33.34l.66.69c.12-.07,3.24-3.25,3.36-3.3,0,.83-.08,2.41.12,3.13.21-.04,1.07-.94,1.23-1.11.05-.05.08-.09.13-.14.33-.35.41-.34.4-.62-.01-1.53.02-3.07,0-4.61h0Z"
            />
            <path
              class="threeCls-15"
              d="M22.28,348.17c-.01-.52-.05-2.55-.18-2.92-.32-.02-1.38,1.14-1.67,1.43-.36.37-.29.21-.29.74v4.13c.21.03,4.17.01,4.73,0,.12,0,.34-.27.47-.4.22-.21,1.21-1.19,1.28-1.39-.28-.17-2.61-.04-3.13-.1l3.3-3.34c-.16-.19-.79-.74-1-.98-.07-.08-.26-.28-.35-.33-.16.09-3.08,3.13-3.19,3.15h0Z"
            />
            <path
              class="threeCls-15"
              d="M6.57,348.16c-.09-.01-.34-.31-.41-.37l-1.18-1.18c-.26-.26-1.44-1.45-1.64-1.54-.24.1-1.18,1.05-1.29,1.3.17.37,2.96,2.95,3.06,3.22-.27.16-2.62.08-3.12.09l1.81,1.86c.09.05.39.02.51.02.27,0,4.07.02,4.22-.01v-4.21c0-.52.1-.41-.28-.77l-1.59-1.55-.1,3.15h0Z"
            />
            <path
              class="threeCls-15"
              d="M16.91,352.27c-.37.05-.53.16-.67.39-.35.56-.21,1.96,1.19,1.66.32-.07.51-.21.64-.42.28-.45.28-.73-.03-1.19-.1-.15-.14-.17-.28-.26-.23-.15-.53-.22-.85-.18h0Z"
            />
            <path
              class="threeCls-15"
              d="M11.4,352.27c-1.35.18-1.31,2.25.31,2.06.66-.08,1.04-.58.91-1.18-.11-.51-.59-.97-1.22-.88h0Z"
            />
            <path
              class="threeCls-15"
              d="M14.36,350.41c.63,0,1.15.51,1.15,1.15s-.51,1.15-1.15,1.15-1.15-.51-1.15-1.15.51-1.15,1.15-1.15h0Z"
            />
            <polygon
              class="threeCls-9"
              points="54.58 351.22 54.58 349.98 49.22 349.98 49.22 345.62 53.72 345.62 53.72 344.38 49.22 344.38 49.22 340.19 54.33 340.19 54.33 338.95 47.82 338.95 47.82 351.22 54.58 351.22 54.58 351.22"
            />
            <path
              class="threeCls-9"
              d="M63.31,343.01h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h0Z"
            />
            <path
              class="threeCls-9"
              d="M77.95,349.44c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM75.31,342.71c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="threeCls-9"
              d="M86.16,341.63c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="threeCls-9"
              d="M94.56,342.1c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.09,0,3.24,1.66,4.46,3.62,4.46,1.22,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM93.22,343.06v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.11,1.56.26h0Z"
            />
            <path
              class="threeCls-9"
              d="M103.53,349.44c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM100.88,342.71c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="threeCls-9"
              d="M114.17,344.66c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="threeCls-9"
              d="M116.52,346.6c0,3.43,1.52,4.78,3.85,4.78,1.63,0,2.43-.58,2.82-1.02l-.84-.95c-.39.44-.98.75-1.86.75-1.59,0-2.57-1.03-2.57-3.75s1.03-3.68,2.57-3.68c.93,0,1.49.39,1.87.79l.91-1c-.35-.4-1.19-1-2.71-1-2.33,0-4.04,1.56-4.04,5.06h0Z"
            />
            <path
              class="threeCls-9"
              d="M124.17,354.71c.23.09.61.18,1.09.18,1.94,0,2.89-1.21,3.48-2.99l3.36-10.19h-1.42l-1.47,4.67c-.61,1.96-.82,2.77-.98,3.47h-.07c-.23-.82-.51-1.75-1.07-3.47l-1.54-4.67h-1.47l3.45,9.86c-.42,1.47-1.07,2.1-2.26,2.1-.26,0-.65-.07-.89-.16l-.21,1.21h0Z"
            />
            <path
              class="threeCls-9"
              d="M52.55,370.01c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM50.57,362.57c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="threeCls-9"
              d="M61.65,369.71c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="threeCls-9"
              d="M69.95,369.71c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="threeCls-9"
              d="M79.82,370.45c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM77.18,363.72c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="threeCls-9"
              d="M89.73,364.02h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h0Z"
            />
            <path
              class="threeCls-9"
              d="M98.31,371.9c.58.3,1.49.51,2.68.51,3.15,0,4.67-2.14,4.67-5.23,0-3.26-1.63-4.55-3.62-4.55-1.19,0-2.01.49-2.31.74h-.07v-4.41h-1.35v12.96h0ZM101.2,371.22c-.59,0-1.16-.11-1.52-.26v-6.2c.44-.6,1.24-.95,2-.95,1.33,0,2.63.79,2.63,3.55,0,2.57-1.24,3.85-3.1,3.85h0Z"
            />
            <path
              class="threeCls-9"
              d="M108.17,358.94v11.4c0,1.24.63,2.01,1.94,2.01.37,0,.84-.05,1.19-.21v-1.16c-.18.09-.44.19-.79.19-.72,0-1-.37-1-1.21v-11.03h-1.35Z"
            />
            <path
              class="threeCls-9"
              d="M112.12,375.72c.23.09.61.18,1.09.18,1.94,0,2.89-1.21,3.48-2.99l3.36-10.19h-1.42l-1.47,4.67c-.61,1.96-.82,2.77-.98,3.47h-.07c-.23-.82-.51-1.75-1.07-3.47l-1.54-4.67h-1.47l3.45,9.86c-.42,1.47-1.07,2.1-2.26,2.1-.26,0-.65-.07-.89-.16l-.21,1.21h0Z"
            />
            <path
              class="threeCls-9"
              d="M134.25,367.08c0-3.09-1.37-4.54-3.54-4.54-1.21,0-2.01.53-2.47,1.14h-.07l-.3-.96h-1.02v12.92h1.35v-3.55c.47.11,1.01.16,1.51.16,2.73,0,4.53-1.84,4.53-5.16h0ZM128.21,370.82v-5.78c.33-.61,1.01-1.33,2.19-1.33,1.26,0,2.47.85,2.47,3.53,0,2.53-1.07,3.79-3.22,3.79-.38,0-1.03-.07-1.44-.21h0Z"
            />
            <path
              class="threeCls-9"
              d="M137.54,367.38c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h0ZM140.03,372.39c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="threeCls-9"
              d="M146.89,372.23h1.37v-9.52h-1.37v9.52h0ZM146.51,359.94c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="threeCls-9"
              d="M158.69,365.67c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="threeCls-9"
              d="M164.28,372.32c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
          </g>
          <g>
            <path
              class="threeCls-9"
              d="M7.52,241.1c-.77,0-1.4-.62-1.4-1.4v-9.3c0-.77.62-1.4,1.4-1.4s1.4.62,1.4,1.4v9.3c0,.77-.62,1.4-1.4,1.4h0Z"
            />
            <path
              class="threeCls-9"
              d="M14.19,236.01h-6.62c-.53,0-.96-.43-.96-.96s.43-.96.96-.96h6.62c.53,0,.96.43.96.96s-.43.96-.96.96h0Z"
            />
            <path
              class="threeCls-9"
              d="M18.82,247.25c-.34,0-.68-.16-.89-.46l-4.08-5.69h-6.25c-.61,0-1.1-.49-1.1-1.1s.49-1.1,1.1-1.1h6.81c.35,0,.69.17.89.46l3.77,5.26,2.2-1.54c.5-.35,1.18-.23,1.53.27.35.5.23,1.18-.27,1.53l-3.09,2.17c-.19.13-.41.2-.63.2h0Z"
            />
            <path
              class="threeCls-9"
              d="M9.68,226.25c0,1.19-.96,2.15-2.15,2.15s-2.15-.96-2.15-2.15.96-2.15,2.15-2.15,2.15.96,2.15,2.15h0Z"
            />
            <path
              class="threeCls-9"
              d="M15.6,244.41c-1.17,1.92-3.28,3.2-5.68,3.2-3.66,0-6.64-2.98-6.64-6.64,0-2.02.91-3.83,2.34-5.05v-1.62c-2.19,1.42-3.64,3.88-3.64,6.67,0,4.38,3.56,7.95,7.95,7.95,2.68,0,5.05-1.33,6.49-3.37l-.81-1.14h0Z"
            />
            <path
              class="threeCls-9"
              d="M48.4,232.55h3.2c3.76,0,5.38-2.26,5.38-6.25s-1.66-6.02-5.36-6.02h-3.22v12.27h0ZM49.8,221.52h1.7c2.61,0,4.04,1.28,4.04,4.94s-1.26,4.85-3.96,4.85h-1.79v-9.79h0Z"
            />
            <path
              class="threeCls-9"
              d="M59.96,232.55h1.37v-9.52h-1.37v9.52h0ZM59.57,220.26c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="threeCls-9"
              d="M69.05,230.03c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="threeCls-9"
              d="M77.78,230.33c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM75.8,222.89c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="threeCls-9"
              d="M82.4,232.22c.58.3,1.49.51,2.68.51,3.15,0,4.67-2.14,4.67-5.23,0-3.26-1.63-4.55-3.62-4.55-1.19,0-2.01.49-2.31.74h-.07v-4.41h-1.35v12.96h0ZM85.29,231.54c-.59,0-1.16-.11-1.52-.26v-6.2c.44-.6,1.24-.95,2-.95,1.33,0,2.63.79,2.63,3.55,0,2.57-1.24,3.85-3.1,3.85h0Z"
            />
            <path
              class="threeCls-9"
              d="M92.26,219.26v11.4c0,1.24.63,2.01,1.94,2.01.37,0,.84-.05,1.19-.21v-1.16c-.18.09-.44.19-.79.19-.72,0-1-.37-1-1.21v-11.03h-1.35Z"
            />
            <path
              class="threeCls-9"
              d="M103.25,230.77c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM100.61,224.04c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="threeCls-9"
              d="M112.24,223.19c-.44-.09-.96-.16-1.52-.16-2.68,0-4.52,1.73-4.52,5.18,0,3.12,1.37,4.53,3.52,4.53,1.24,0,2.12-.6,2.49-1.16h.07l.3.96h1.01v-13.29h-1.35v3.92h0ZM110.01,231.57c-1.26,0-2.43-.86-2.43-3.52s1.1-3.83,3.2-3.83c.44,0,1.09.11,1.45.23v5.58c-.37.89-1.09,1.54-2.22,1.54h0Z"
            />
            <path
              class="threeCls-9"
              d="M53.45,245.44l1.94,8.12h1.84l2.56-9.52h-1.31l-1.35,5.23c-.26,1-.51,2.05-.74,3.08h-.07c-.19-.96-.4-1.82-.61-2.7l-1.4-5.62h-1.75l-1.43,5.62c-.23.88-.42,1.77-.61,2.7h-.07c-.21-1.05-.45-2.05-.72-3.06l-1.33-5.25h-1.4l2.52,9.52h1.84l2.03-8.12h.07Z"
            />
            <path
              class="threeCls-9"
              d="M66.33,251.34c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM64.35,243.9c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="threeCls-9"
              d="M75.44,251.04c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="threeCls-9"
              d="M83.44,243.88c-1.61,0-2.47.88-2.75,1.21h-.07v-4.81h-1.37v13.29h1.37v-6.79c.33-.82,1.23-1.68,2.54-1.68s1.93.91,1.93,2.1v6.37h1.37v-6.58c0-1.94-1.17-3.1-3.01-3.1h0Z"
            />
            <path
              class="threeCls-9"
              d="M94.06,243.97c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="threeCls-9"
              d="M96.51,248.71c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h0ZM99,253.72c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="threeCls-9"
              d="M106.3,248.71c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h0ZM108.79,253.72c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="threeCls-9"
              d="M121.65,245.35h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h0Z"
            />
          </g>
          <g>
            <polygon
              class="threeCls-11"
              points="8.35 409.01 14.35 409.01 14.35 402.63 20.73 402.63 20.73 396.62 14.35 396.62 14.35 390.24 8.35 390.24 8.35 396.62 1.97 396.62 1.97 402.63 8.35 402.63 8.35 409.01 8.35 409.01"
            />
            <polygon
              class="threeCls-9"
              points="48.64 406.17 48.64 400.9 53.09 400.9 53.09 399.66 48.64 399.66 48.64 395.14 53.7 395.14 53.7 393.9 47.22 393.9 47.22 406.17 48.64 406.17 48.64 406.17"
            />
            <path
              class="threeCls-9"
              d="M56.12,406.17h1.37v-9.52h-1.37v9.52h0ZM55.73,393.88c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="threeCls-9"
              d="M71.52,403.65c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="threeCls-9"
              d="M78.07,406.26c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
            <path
              class="threeCls-9"
              d="M91.97,403.95c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM89.99,396.51c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="threeCls-9"
              d="M97.05,406.17h1.37v-9.52h-1.37v9.52h0ZM96.66,393.88c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="threeCls-9"
              d="M107.18,396.81c-.44-.09-.96-.16-1.52-.16-2.68,0-4.52,1.73-4.52,5.18,0,3.12,1.37,4.53,3.52,4.53,1.24,0,2.12-.6,2.49-1.16h.07l.3.96h1.01v-13.29h-1.35v3.92h0ZM104.96,405.19c-1.26,0-2.43-.86-2.43-3.52s1.1-3.83,3.2-3.83c.44,0,1.09.1,1.45.23v5.58c-.37.89-1.09,1.54-2.22,1.54h0Z"
            />
            <path
              class="threeCls-9"
              d="M65.48,396.58c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
          </g>
          <g>
            <polygon
              class="threeCls-9"
              points="53.98 318.14 53.98 316.89 48.62 316.89 48.62 312.54 53.12 312.54 53.12 311.29 48.62 311.29 48.62 307.11 53.73 307.11 53.73 305.86 47.22 305.86 47.22 318.14 53.98 318.14 53.98 318.14"
            />
            <path
              class="threeCls-9"
              d="M62.72,309.93h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h0Z"
            />
            <path
              class="threeCls-9"
              d="M77.35,316.35c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM74.71,309.63c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="threeCls-9"
              d="M85.56,308.54c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="threeCls-9"
              d="M93.97,309.02c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.09,0,3.24,1.66,4.46,3.62,4.46,1.23,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM92.62,309.98v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.11,1.56.26h0Z"
            />
            <path
              class="threeCls-9"
              d="M102.93,316.35c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM100.29,309.63c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="threeCls-9"
              d="M113.57,311.57c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="threeCls-9"
              d="M115.92,313.52c0,3.43,1.52,4.78,3.85,4.78,1.63,0,2.43-.58,2.82-1.02l-.84-.95c-.39.44-.98.75-1.86.75-1.59,0-2.57-1.03-2.57-3.75s1.03-3.68,2.57-3.68c.93,0,1.49.39,1.87.79l.91-1c-.35-.4-1.19-1-2.71-1-2.33,0-4.04,1.56-4.04,5.06h0Z"
            />
            <path
              class="threeCls-9"
              d="M123.57,321.62c.23.09.61.18,1.09.18,1.94,0,2.89-1.21,3.48-2.99l3.36-10.19h-1.42l-1.47,4.67c-.61,1.96-.82,2.77-.98,3.47h-.07c-.23-.82-.51-1.75-1.07-3.47l-1.54-4.67h-1.47l3.45,9.86c-.42,1.47-1.07,2.1-2.26,2.1-.26,0-.65-.07-.89-.16l-.21,1.21h0Z"
            />
            <path
              class="threeCls-9"
              d="M144.37,316.35c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM141.73,309.63c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <polygon
              class="threeCls-9"
              points="152.86 318.14 154.44 318.14 151.37 313.22 154.26 308.61 152.67 308.61 150.64 312.15 150.57 312.15 148.43 308.61 146.86 308.61 149.76 313.18 146.68 318.14 148.28 318.14 150.5 314.27 150.57 314.27 152.86 318.14 152.86 318.14"
            />
            <path
              class="threeCls-9"
              d="M156.68,318.14h1.37v-9.52h-1.37v9.52h0ZM156.29,305.85c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="threeCls-9"
              d="M164.01,318.23c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
            <path
              class="threeCls-15"
              d="M8.2,302.39c-1.1-.29-1.93.6-2.12,1.42-.27,1.15.46,2.06,1.28,2.29,2.33.64,3.18-3.08.84-3.7h0ZM6.49,311.35l.46-.56c.23-.25.44-.72.74-.87.18.19.15.23.28.48l.71,1.35c.11.4.61,1.09.69,1.43.06.25-.44,1.24-.55,1.52l-3.18,7.53c-.16.38-.55,1.18-.6,1.5,1.98.12,2.19.08,2.76-1.12.4-.83.82-1.76,1.22-2.6.3-.63,2.31-4.98,2.49-5.16.24.73.37,2,.55,2.85.09.47.15.91.29,1.37.15.51.32.72.89.78h6.73c-.06-.33-.48-1.15-.63-1.49-.27-.61-.35-.83-1.17-.86-1.24-.04-2.87.11-4.04-.03-.19-1.18-.46-4.09-.82-4.98-.28-.7-.58-1.36-.87-2.02-.74-1.74-1.13-2.16-.25-2.18h1.74c.17.35,1.64,2.95,1.99,3.07.48.17.95-.22,1.06-.56.14-.45-.23-.91-.41-1.26-.45-.84-1.37-2.82-1.93-3.06-.42-.18-2.65-.09-3.3-.09-2.46,0-3.47-.38-4.91,1.81-.27.41-1.03,1.82-1.3,1.99-.15-.01-.14-.06-.11.05-.54.03-1.48.08-2.04,0v-9.2c1.37.1,3.17,0,4.61-.01l4.49-.02s.04,0,.05-.02c0-.02.03-.01.04-.02l5.6.02v15.98c1.67.21,1.47-.33,2.21,1.2.22.45,1,1.9,1.06,2.28h-3.21c-.07.5-.11,3.18.06,3.44.12.19.67.72.86.93.14.16.73.75.79.91-2.92.12-6.48,0-9.55,0-.85,0-.59.11-1.26-.64-.45-.5-.64-.85-1.07-.87-.6-.03-1.29,0-1.9,0,.07.23,0,.11.15.31l.48.5c.17.19.51.52.61.67-.5.06-1.65.05-2.18.02-.37-.02-.43-.23-.63-.46-.17-.19-.33-.34-.51-.53-.79-.82-.72-.66-.72-1.46.02-3.58-.07-7.25,0-10.8.73-.05,1.71.07,2.39-.02.63-.09.77-.77,1.16-1.13h0Z"
            />
          </g>
          <g>
            <polygon
              class="threeCls-9"
              points="48.64 284.04 48.64 278.77 53.09 278.77 53.09 277.52 48.64 277.52 48.64 273.01 53.7 273.01 53.7 271.76 47.22 271.76 47.22 284.04 48.64 284.04 48.64 284.04"
            />
            <path
              class="threeCls-9"
              d="M56.12,284.04h1.37v-9.52h-1.37v9.52h0ZM55.73,271.75c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="threeCls-9"
              d="M65.48,274.44c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="threeCls-9"
              d="M73.1,282.25c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM70.45,275.53c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="threeCls-9"
              d="M87.65,282.25c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM85,275.53c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <polygon
              class="threeCls-9"
              points="96.14 284.04 97.71 284.04 94.65 279.12 97.54 274.51 95.94 274.51 93.91 278.05 93.84 278.05 91.71 274.51 90.13 274.51 93.04 279.08 89.96 284.04 91.55 284.04 93.77 280.17 93.84 280.17 96.14 284.04 96.14 284.04"
            />
            <path
              class="threeCls-9"
              d="M102.23,284.13c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
            <path
              class="threeCls-9"
              d="M106.62,284.04h1.37v-9.52h-1.37v9.52h0ZM106.24,271.75c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="threeCls-9"
              d="M118.42,277.47c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="threeCls-9"
              d="M128.12,274.92c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.09,0,3.24,1.66,4.46,3.62,4.46,1.22,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM126.78,275.88v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.11,1.56.26h0Z"
            />
            <path
              class="threeCls-9"
              d="M130.98,281.03c.05,2.17,1.14,3.2,3.1,3.2,1.59,0,2.45-.82,2.71-1.19h.07l.26,1h1.07v-9.52h-1.37v6.25c-.03,1.51-1.03,2.29-2.4,2.29s-2.08-.75-2.08-2.31v-6.23h-1.37v6.51h0Z"
            />
            <path
              class="threeCls-9"
              d="M141.55,284.04h1.37v-9.52h-1.37v9.52h0ZM141.17,271.75c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="threeCls-9"
              d="M150.64,281.52c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="threeCls-9"
              d="M158.64,274.36c-1.61,0-2.47.88-2.75,1.21h-.07v-4.81h-1.37v13.29h1.37v-6.79c.33-.82,1.23-1.68,2.54-1.68s1.93.91,1.93,2.1v6.37h1.37v-6.58c0-1.94-1.17-3.1-3.01-3.1h0Z"
            />
            <path
              class="threeCls-9"
              d="M170.56,282.25c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM167.92,275.53c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="threeCls-9"
              d="M178.77,274.44c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="threeCls-15"
              d="M4.57,276.14s.02-.03.1-.04c0,0,.08,0,.09,0h5.89c.4,0,.29.01.32.09v3.76s-6.38,0-6.38,0c-.08-.08-.03.03-.06-.1v-.37c0-.4-.07-3.14.04-3.32h0ZM3.56,273.82c0,2.93-.01,5.88-.01,8.82s-.07,5.95,0,8.87h8.32s0-17.54,0-17.54c.04-.7-.42-1.27-.74-1.57-.59-.54-.86-.47-1.75-.58v-1.88c.4-.05.58.04.97-.1.27-.09.61-.14.83-.29v-1.27c-1.58-.42-.15-.26-2.06-.31v-1.07s-2.5-.01-2.5-.01v.93c-1.97.05-.85-.25-2.68,1.21-.23.18-.5.4-.7.61-.56.56-.78.51-1.06,1.56-.22.82-.19,1.59-.17,2.49h.94c.15-1.71,0-1.5,1.07-2.46.32-.28.6-.58.9-.88.4-.4.51-.61,1.28-.45v1.91c-.57.09-1.03-.12-1.8.49-.32.25-.83.87-.82,1.51h0Z"
            />
            <path
              class="threeCls-15"
              d="M25.73,285.03v-2.62c-.36-.15-.81-.27-1.2-.42-1.2-.49-2.16-1.1-3.11-1.89-.77-.65-1.7-1.82-2.27-2.73-.2-.33-.39-.73-.61-1.05-.15,1,.29,2.54.61,3.34.72,1.79,2.03,3.35,3.58,4.36.59.38,2.06,1.1,2.99,1.02h0Z"
            />
            <path
              class="threeCls-15"
              d="M17.32,272.18c.16.26.9.59,1.77,2.27,1.1,2.11,2.06,5.33,4.34,5.71.48.08,1.37.07,1.75-.17-.55-.36-1.08-.19-2.07-1.89-1.14-1.95-1.83-5.5-4.02-6.03-.73-.17-1.14-.02-1.77.11h0Z"
            />
            <path
              class="threeCls-15"
              d="M16.45,283.61c3.22.17,4.62,5.31,7.68,4.1.23-.09.41-.19.59-.3.21-.13.33-.24.49-.35-1.04-.36-1.54-.66-2.22-1.28-1.62-1.5-3.29-3.81-5.49-2.87-.3.13-.93.47-1.05.7h0Z"
            />
            <path
              class="threeCls-15"
              d="M25.73,291.55v-2.69c-.77.01-1.05.21-2.25.07-1.81-.22-3.73-1.07-4.82-2.29-.01.55.6,1.75.86,2.15,1.23,1.88,3.84,3.43,6.22,2.77h0Z"
            />
            <path
              class="threeCls-15"
              d="M25.73,278.17v-2.67c-.55-.44-.38-.17-1.18-.91-1.17-1.09-1.8-2.71-1.84-4.48l-.05.06c-.16.26-.28.78-.33,1.08-.09.45-.11.93-.09,1.4.04.88.25,1.73.54,2.45.34.82.67,1.29,1.14,1.85.25.3,1.17,1.19,1.82,1.22h0Z"
            />
          </g>
          <g>
            <path
              class="threeCls-6"
              d="M17.93,422.92H4c-1.12,0-2.03.91-2.03,2.03v13.93c0,1.12.91,2.03,2.03,2.03h13.93c1.12,0,2.03-.91,2.03-2.03v-13.93c0-1.12-.91-2.03-2.03-2.03h0Z"
            />
            <path
              class="threeCls-9"
              d="M10.47,433.51h-.91v3.91h-2.4v-11h3.77c2.23,0,3.84.83,3.84,3.26,0,2.06-1.08,3.83-4.3,3.83h0ZM10.54,428.45h-.97v3.11h.79c1.6,0,1.95-.69,1.95-1.54,0-1.08-.53-1.57-1.76-1.57h0Z"
            />
            <path
              class="threeCls-9"
              d="M50.76,424.38h-3.54v12.27h1.4v-4.85h1.87c2.82,0,4.24-1.45,4.24-3.9s-1.54-3.52-3.97-3.52h0ZM50.44,425.63c1.86,0,2.84.68,2.84,2.43,0,1.63-.75,2.52-2.78,2.52h-1.87v-4.95h1.82Z"
            />
            <path
              class="threeCls-9"
              d="M60.91,434.43c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM58.94,426.99c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.46.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.1v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="threeCls-9"
              d="M70.3,427.06c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.23,2.35-1.23.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="threeCls-9"
              d="M73.22,423.37h-1.37v13.29h1.37v-13.29h0ZM73.48,431.77l3.59,4.88h1.73l-3.73-4.92v-.07l3.52-4.53h-1.7l-3.41,4.57v.07h0Z"
            />
            <path
              class="threeCls-9"
              d="M81.08,436.66h1.37v-9.52h-1.37v9.52h0ZM80.7,424.37c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="threeCls-9"
              d="M92.88,430.09c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="threeCls-9"
              d="M102.58,427.54c-.58-.28-1.51-.49-2.71-.49-3.15,0-4.64,2.05-4.64,5.1,0,3.24,1.66,4.46,3.62,4.46,1.22,0,2.03-.49,2.33-.75h.07v.88c0,1.7-.7,2.54-2.43,2.54-1.28,0-2.03-.42-2.5-.89l-.79,1.09c.39.38,1.33,1.01,3.13,1.01,2.38,0,3.92-1.24,3.92-3.75v-9.19h0ZM101.23,428.5v5.99c-.45.6-1.26.93-2.01.93-1.35,0-2.61-.72-2.61-3.45,0-2.52,1.23-3.73,3.06-3.73.61,0,1.16.1,1.56.26h0Z"
            />
          </g>
          <g>
            <path
              class="threeCls-9"
              d="M10.19,123.38c0,1.24-1.01,2.25-2.25,2.25s-2.25-1.01-2.25-2.25,1.01-2.25,2.25-2.25,2.25,1.01,2.25,2.25h0Z"
            />
            <path
              class="threeCls-9"
              d="M13.9,134.27l-1.54-6.68c-.05-.75-.79-1.34-1.68-1.34h-5.45c-.9,0-1.63.59-1.68,1.34l-1.54,6.68c-.1.42.22.82.72.9.49.08.97-.19,1.07-.61l1.56-6.74s0-.02,0-.04h.32l-1.91,9.9c-.03.16.02.32.15.44.12.12.3.19.49.19h1.43v6.85c0,.42.41.77.91.77s.91-.34.91-.77v-6.85h.63v6.85c0,.43.41.77.91.77s.91-.34.91-.77v-6.85h1.43c.36,0,.65-.25.65-.55,0-.05,0-.11-.03-.16l-1.9-9.83h.32s0,.02,0,.04l1.56,6.74c.09.37.47.62.89.62.06,0,.12,0,.18-.01.49-.08.81-.48.72-.9h0Z"
            />
            <polygon
              class="threeCls-9"
              points="47.22 117.31 47.22 129.58 53.89 129.58 53.89 128.34 48.62 128.34 48.62 117.31 47.22 117.31 47.22 117.31"
            />
            <path
              class="threeCls-9"
              d="M60.55,127.36c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM58.57,119.92c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="threeCls-9"
              d="M70.7,120.21c-.44-.09-.96-.16-1.52-.16-2.68,0-4.52,1.73-4.52,5.18,0,3.12,1.37,4.53,3.52,4.53,1.24,0,2.12-.6,2.49-1.16h.07l.3.96h1.01v-13.29h-1.35v3.92h0ZM68.48,128.6c-1.26,0-2.43-.86-2.43-3.52s1.1-3.83,3.2-3.83c.44,0,1.09.11,1.45.23v5.58c-.37.89-1.09,1.54-2.22,1.54h0Z"
            />
            <path
              class="threeCls-9"
              d="M75.41,129.58h1.37v-9.52h-1.37v9.52h0ZM75.02,117.29c0,.56.44.98.98.98.58,0,1.02-.42,1.02-.98s-.44-1-1.02-1c-.54,0-.98.42-.98,1h0Z"
            />
            <path
              class="threeCls-9"
              d="M86.07,127.79c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.11-1.17.11-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM83.43,121.07c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="threeCls-9"
              d="M94,127.06c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.87-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="threeCls-9"
              d="M52.26,142.47l1.94,8.12h1.84l2.56-9.52h-1.31l-1.35,5.23c-.26,1-.51,2.05-.74,3.08h-.07c-.19-.96-.4-1.82-.61-2.7l-1.4-5.62h-1.75l-1.43,5.62c-.23.88-.42,1.77-.61,2.7h-.07c-.21-1.05-.45-2.05-.72-3.06l-1.33-5.25h-1.4l2.52,9.52h1.84l2.03-8.12h.07Z"
            />
            <path
              class="threeCls-9"
              d="M65.15,148.37c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM63.17,140.93c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="threeCls-9"
              d="M74.25,148.07c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="threeCls-9"
              d="M82.25,140.91c-1.61,0-2.47.88-2.75,1.21h-.07v-4.81h-1.37v13.29h1.37v-6.79c.33-.82,1.23-1.68,2.54-1.68s1.93.91,1.93,2.1v6.37h1.37v-6.58c0-1.94-1.17-3.1-3.01-3.1h0Z"
            />
            <path
              class="threeCls-9"
              d="M92.88,140.99c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.23,2.35-1.23.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="threeCls-9"
              d="M95.33,145.74c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h0ZM97.82,150.75c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="threeCls-9"
              d="M105.12,145.74c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.67,3.69-2.5,3.69-2.59-1.26-2.59-3.82h0ZM107.6,150.75c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="threeCls-9"
              d="M120.47,142.38h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h0Z"
            />
          </g>
          <g>
            <path
              class="threeCls-9"
              d="M8.55,174.84c0,1.23-.99,2.22-2.22,2.22s-2.22-1-2.22-2.22,1-2.22,2.22-2.22,2.22,1,2.22,2.22h0Z"
            />
            <path
              class="threeCls-9"
              d="M9.02,177.68H3.64c-.92,0-1.67.63-1.67,1.41v6.65c0,.42.4.76.9.76s.9-.34.9-.76v-6.55h.46v17.48c0,.42.4.76.9.76s.9-.34.9-.76v-9.63h.62v9.63c0,.42.4.76.9.76s.9-.34.9-.76v-17.47h.46v6.55c0,.42.4.76.9.76s.9-.34.9-.76v-6.65c0-.78-.75-1.41-1.67-1.41h0Z"
            />
            <path
              class="threeCls-9"
              d="M51.9,168.62c-2.92,0-5.27,1.93-5.27,6.36,0,4.18,1.68,6.27,4.85,6.27,1.89,0,3.06-.46,3.85-1.1v-5.3h-1.4v4.69c-.49.33-1.37.49-2.15.49-2.4,0-3.71-1.47-3.71-5.16,0-4.01,1.96-4.96,3.75-4.96,1.22,0,2.03.33,2.56.84l.91-1.07c-.4-.38-1.35-1.05-3.38-1.05h0Z"
            />
            <path
              class="threeCls-9"
              d="M64.21,179.28c-.4.35-1.26.72-2.21.72-1.91,0-2.89-.89-3.01-3.24h6.06c.07-.61.1-1.17.1-1.65,0-2.26-1.21-3.73-3.47-3.73-2.12,0-4.04,1.42-4.04,4.87s1.47,4.94,4.18,4.94c1.37,0,2.36-.39,2.99-.86l-.61-1.05h0ZM61.56,172.56c1.54,0,2.24.91,2.24,2.54,0,.12,0,.33-.02.54h-4.78c.12-2.29,1.31-3.08,2.56-3.08h0Z"
            />
            <path
              class="threeCls-9"
              d="M74.85,174.5c-.05-2.12-1.19-3.15-3.1-3.15-1.49,0-2.45.86-2.71,1.19h-.07l-.28-1h-1.03v9.52h1.37v-6.81c.33-.93,1.24-1.7,2.42-1.7,1.33,0,2.05.81,2.05,2.26v6.25h1.37v-6.57h0Z"
            />
            <path
              class="threeCls-9"
              d="M80.44,181.15c1.14,0,1.77-.23,2.14-.44l-.38-1.09c-.25.16-.68.33-1.45.33-.84,0-1.38-.44-1.38-1.51v-5.81h2.63v-1.1h-2.63v-2.5h-.93l-.42,2.47-1.42.26v.88h1.42v5.88c0,1.8.86,2.63,2.43,2.63h0Z"
            />
            <path
              class="threeCls-9"
              d="M88.86,178.54c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="threeCls-9"
              d="M52.25,193.95l1.94,8.12h1.84l2.56-9.52h-1.31l-1.35,5.23c-.26,1-.51,2.05-.74,3.08h-.07c-.19-.96-.4-1.82-.61-2.7l-1.4-5.62h-1.75l-1.44,5.62c-.23.88-.42,1.77-.61,2.7h-.07c-.21-1.05-.45-2.05-.72-3.06l-1.33-5.25h-1.4l2.52,9.52h1.84l2.03-8.12h.07Z"
            />
            <path
              class="threeCls-9"
              d="M65.14,199.85c-.44.65-1.3,1.3-2.38,1.3s-1.72-.68-1.72-1.52c0-1.44,1.8-2,4.1-1.91v2.14h0ZM63.16,192.41c-1.98,0-2.87,1.1-3.2,1.56l1,.79c.28-.45.89-1.16,2.17-1.16s2.01.46,2.01,2.01v1.03c-3.38-.05-5.44.98-5.44,3.08,0,1.3.98,2.54,2.75,2.54,1.61,0,2.38-.75,2.84-1.28h.07c.23.65.79,1.16,1.73,1.16.18,0,.37-.04.49-.11v-1h-.24c-.67,0-.93-.58-.93-1.44v-4.31c0-2-1.21-2.89-3.24-2.89h0Z"
            />
            <path
              class="threeCls-9"
              d="M74.24,199.55c0,.81-.65,1.51-1.98,1.51-1.1,0-2.01-.45-2.59-1.05l-.84,1.02c.6.61,1.79,1.21,3.36,1.21,2.29,0,3.4-1.4,3.4-2.71,0-3.24-4.81-2.38-4.81-4.52,0-.77.58-1.42,1.87-1.42.74,0,1.51.32,1.94.77l.88-.95c-.58-.61-1.65-1.01-2.78-1.01-2.08,0-3.26,1.28-3.26,2.64,0,3.22,4.81,2.36,4.81,4.52h0Z"
            />
            <path
              class="threeCls-9"
              d="M82.24,192.39c-1.61,0-2.47.88-2.75,1.21h-.07v-4.81h-1.37v13.29h1.37v-6.79c.33-.82,1.23-1.68,2.54-1.68s1.93.91,1.93,2.1v6.37h1.37v-6.58c0-1.94-1.17-3.1-3.01-3.1h0Z"
            />
            <path
              class="threeCls-9"
              d="M92.87,192.48c-.21-.05-.53-.09-.96-.09-1.1,0-1.98.53-2.4,1.21h-.07l-.3-1.05h-1.03v9.52h1.35v-7.09c.45-.86,1.42-1.22,2.35-1.22.35,0,.72.03,1.07.14v-1.42h0Z"
            />
            <path
              class="threeCls-9"
              d="M95.32,197.23c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h0ZM97.8,202.23c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="threeCls-9"
              d="M105.1,197.23c0-2.47.68-3.68,2.49-3.68s2.61,1.24,2.61,3.8-.66,3.69-2.5,3.69-2.59-1.26-2.59-3.82h0ZM107.59,202.23c2.89,0,4.01-2.05,4.01-4.99s-1-4.87-3.9-4.87-3.99,2.01-3.99,4.96,1,4.9,3.89,4.9h0Z"
            />
            <path
              class="threeCls-9"
              d="M120.46,193.86h-.07c-.35-.86-1.1-1.51-2.52-1.51-1.49,0-2.21.81-2.47,1.21h-.07l-.28-1.02h-1.05v9.52h1.37v-6.81c.19-.82.96-1.7,2.15-1.7s1.89.82,1.89,2.33v6.18h1.37v-6.92c.25-.77,1-1.59,2.19-1.59s1.87.75,1.87,2.22v6.29h1.35v-6.57c0-2.08-1.05-3.15-2.94-3.15-1.49,0-2.42.74-2.78,1.51h0Z"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                class="threeCls-9"
                d="M489.3,720.4c-.35-.5-1.03-.62-1.53-.27l-2.2,1.55-3.77-5.26c-.21-.29-.54-.46-.89-.46h-5.49v-2.9h5.27c.53,0,.96-.43.96-.96s-.43-.96-.96-.96h-5.27v-3.69c0-.77-.62-1.4-1.4-1.4s-1.4.62-1.4,1.4v9.3c0,.77.63,1.4,1.4,1.4.01,0,.02,0,.04,0,.01,0,.02,0,.04,0h6.25l4.08,5.69c.21.3.55.46.89.46.22,0,.44-.06.63-.2l3.09-2.17c.5-.35.62-1.03.27-1.53Z"
              />
              <path
                class="threeCls-9"
                d="M474.02,705.46c1.19,0,2.15-.96,2.15-2.15s-.96-2.15-2.15-2.15-2.15.96-2.15,2.15.96,2.15,2.15,2.15Z"
              />
              <path
                class="threeCls-9"
                d="M476.41,724.66c-3.66,0-6.64-2.98-6.64-6.64,0-2.02.91-3.83,2.34-5.05v-1.62c-2.19,1.42-3.64,3.88-3.64,6.67,0,4.38,3.56,7.95,7.95,7.95,2.68,0,5.05-1.33,6.49-3.37l-.81-1.14c-1.17,1.92-3.28,3.2-5.68,3.2Z"
              />
            </g>
            <g>
              <path
                class="threeCls-9"
                d="M492.07,711.58h1.53c1.79,0,2.56-1.13,2.56-3.12s-.79-3.01-2.55-3.01h-1.53v6.14h0ZM492.74,706.07h.81c1.24,0,1.93.64,1.93,2.47s-.6,2.43-1.88,2.43h-.85v-4.89h0Z"
              />
              <path
                class="threeCls-9"
                d="M497.58,711.58h.65v-4.76h-.65v4.76h0ZM497.39,705.44c0,.28.21.49.47.49.28,0,.48-.21.48-.49s-.21-.5-.48-.5c-.26,0-.47.21-.47.5h0Z"
              />
              <path
                class="threeCls-9"
                d="M501.9,710.32c0,.4-.31.75-.94.75-.53,0-.96-.23-1.23-.53l-.4.51c.28.31.85.6,1.6.6,1.09,0,1.62-.7,1.62-1.36,0-1.62-2.29-1.19-2.29-2.26,0-.38.28-.71.89-.71.35,0,.72.16.92.39l.42-.47c-.27-.31-.78-.51-1.33-.51-.99,0-1.55.64-1.55,1.32,0,1.61,2.29,1.18,2.29,2.26h0Z"
              />
              <path
                class="threeCls-9"
                d="M506.07,710.47c-.21.32-.62.65-1.13.65s-.82-.34-.82-.76c0-.72.86-1,1.95-.95v1.07h0ZM505.12,706.75c-.94,0-1.37.55-1.53.78l.47.39c.13-.23.43-.58,1.03-.58s.96.23.96,1.01v.52c-1.61-.03-2.59.49-2.59,1.54,0,.65.47,1.27,1.31,1.27.77,0,1.13-.38,1.35-.64h.03c.11.32.37.58.83.58.08,0,.18-.02.23-.05v-.5h-.12c-.32,0-.44-.29-.44-.72v-2.15c0-1-.58-1.44-1.54-1.44h0Z"
              />
              <path
                class="threeCls-9"
                d="M508.27,711.41c.28.15.71.25,1.28.25,1.5,0,2.23-1.07,2.23-2.62,0-1.63-.78-2.28-1.73-2.28-.57,0-.96.24-1.1.37h-.03v-2.21h-.64v6.48h0ZM509.64,711.07c-.28,0-.55-.05-.73-.13v-3.1c.21-.3.59-.47.95-.47.63,0,1.25.39,1.25,1.78,0,1.29-.59,1.93-1.48,1.93h0Z"
              />
              <path
                class="threeCls-9"
                d="M512.96,704.94v5.7c0,.62.3,1.01.93,1.01.17,0,.4-.03.57-.1v-.58c-.08.04-.21.1-.38.1-.34,0-.47-.18-.47-.6v-5.51h-.64Z"
              />
              <path
                class="threeCls-9"
                d="M518.2,710.69c-.19.17-.6.36-1.05.36-.91,0-1.38-.45-1.44-1.62h2.89c.03-.31.05-.59.05-.82,0-1.13-.58-1.86-1.65-1.86-1.01,0-1.93.71-1.93,2.43s.7,2.47,1.99,2.47c.65,0,1.13-.19,1.43-.43l-.29-.53h0ZM516.94,707.33c.73,0,1.07.45,1.07,1.27,0,.06,0,.17,0,.27h-2.28c.06-1.15.63-1.54,1.22-1.54h0Z"
              />
              <path
                class="threeCls-9"
                d="M522.48,706.9c-.21-.04-.46-.08-.73-.08-1.28,0-2.15.87-2.15,2.59,0,1.56.65,2.27,1.68,2.27.59,0,1.01-.3,1.18-.58h.03l.14.48h.48v-6.64h-.64v1.96h0ZM521.42,711.09c-.6,0-1.16-.43-1.16-1.76s.52-1.92,1.53-1.92c.21,0,.52.05.69.11v2.79c-.18.45-.52.77-1.06.77h0Z"
              />
              <path
                class="threeCls-9"
                d="M494.47,718.02l.92,4.06h.88l1.22-4.76h-.63l-.64,2.62c-.13.5-.24,1.02-.35,1.54h-.03c-.09-.48-.19-.91-.29-1.35l-.67-2.81h-.83l-.68,2.81c-.11.44-.2.88-.29,1.35h-.03c-.1-.53-.22-1.02-.34-1.53l-.63-2.63h-.67l1.2,4.76h.88l.97-4.06h.03Z"
              />
              <path
                class="threeCls-9"
                d="M500.61,720.97c-.21.32-.62.65-1.13.65s-.82-.34-.82-.76c0-.72.86-1,1.95-.95v1.07h0ZM499.67,717.25c-.94,0-1.37.55-1.53.78l.47.39c.13-.23.43-.58,1.03-.58s.96.23.96,1.01v.52c-1.61-.03-2.59.49-2.59,1.54,0,.65.47,1.27,1.31,1.27.77,0,1.13-.38,1.35-.64h.03c.11.32.37.58.83.58.08,0,.18-.02.23-.05v-.5h-.12c-.32,0-.44-.29-.44-.72v-2.15c0-1-.58-1.44-1.54-1.44h0Z"
              />
              <path
                class="threeCls-9"
                d="M504.95,720.82c0,.4-.31.75-.94.75-.53,0-.96-.23-1.23-.53l-.4.51c.28.31.85.6,1.6.6,1.09,0,1.62-.7,1.62-1.36,0-1.62-2.29-1.19-2.29-2.26,0-.38.27-.71.89-.71.35,0,.72.16.93.39l.42-.47c-.28-.31-.78-.51-1.33-.51-.99,0-1.55.64-1.55,1.32,0,1.61,2.29,1.18,2.29,2.26h0Z"
              />
              <path
                class="threeCls-9"
                d="M508.76,717.24c-.77,0-1.18.44-1.31.6h-.03v-2.41h-.65v6.64h.65v-3.4c.16-.41.58-.84,1.21-.84s.92.45.92,1.05v3.19h.65v-3.29c0-.97-.56-1.55-1.43-1.55h0Z"
              />
              <path
                class="threeCls-9"
                d="M513.82,717.29c-.1-.03-.25-.04-.46-.04-.53,0-.94.26-1.14.6h-.03l-.14-.53h-.49v4.76h.64v-3.55c.22-.43.68-.61,1.12-.61.17,0,.34.02.51.07v-.71h0Z"
              />
              <path
                class="threeCls-9"
                d="M514.99,719.66c0-1.23.33-1.84,1.18-1.84s1.24.62,1.24,1.9-.32,1.85-1.19,1.85-1.23-.63-1.23-1.91h0ZM516.17,722.16c1.38,0,1.91-1.02,1.91-2.49s-.47-2.43-1.86-2.43-1.9,1.01-1.9,2.48.48,2.45,1.85,2.45h0Z"
              />
              <path
                class="threeCls-9"
                d="M519.65,719.66c0-1.23.33-1.84,1.18-1.84s1.24.62,1.24,1.9-.32,1.85-1.19,1.85-1.23-.63-1.23-1.91h0ZM520.84,722.16c1.38,0,1.91-1.02,1.91-2.49s-.48-2.43-1.86-2.43-1.9,1.01-1.9,2.48.48,2.45,1.85,2.45h0Z"
              />
              <path
                class="threeCls-9"
                d="M526.97,717.98h-.03c-.17-.43-.53-.75-1.2-.75-.71,0-1.05.4-1.18.6h-.03l-.13-.51h-.5v4.76h.65v-3.41c.09-.41.46-.85,1.03-.85s.9.41.9,1.16v3.09h.65v-3.46c.12-.39.47-.8,1.04-.8s.89.38.89,1.11v3.14h.64v-3.28c0-1.04-.5-1.58-1.4-1.58-.71,0-1.15.37-1.33.75h0Z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                class="threeCls-9"
                d="M476.71,756.32c0,1.23-1,2.22-2.22,2.22s-2.22-1-2.22-2.22,1-2.22,2.22-2.22,2.22,1,2.22,2.22h0Z"
              />
              <path
                class="threeCls-9"
                d="M477.18,759.16h-5.39c-.92,0-1.67.63-1.67,1.41v6.65c0,.42.4.76.9.76s.9-.34.9-.76v-6.55h.46v17.47c0,.42.4.76.9.76s.9-.34.9-.76v-9.63h.62v9.63c0,.42.4.76.9.76s.9-.34.9-.76v-17.47h.46v6.55c0,.42.4.76.9.76s.9-.34.9-.76v-6.65c0-.78-.75-1.41-1.67-1.41h0Z"
              />
            </g>
            <g>
              <path
                class="threeCls-9"
                d="M490.17,758.3c-1.46,0-2.63.96-2.63,3.18,0,2.09.84,3.13,2.42,3.13.95,0,1.53-.23,1.93-.55v-2.65h-.7v2.35c-.25.17-.68.24-1.08.24-1.2,0-1.86-.74-1.86-2.58,0-2,.98-2.48,1.87-2.48.61,0,1.02.17,1.28.42l.46-.53c-.2-.19-.67-.53-1.69-.53h0Z"
              />
              <path
                class="threeCls-9"
                d="M496.33,763.64c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM495,760.27c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
              />
              <path
                class="threeCls-9"
                d="M501.65,761.24c-.03-1.06-.6-1.58-1.55-1.58-.74,0-1.23.43-1.36.6h-.03l-.14-.5h-.52v4.76h.68v-3.41c.17-.46.62-.85,1.21-.85.67,0,1.02.4,1.02,1.13v3.12h.68v-3.28h0Z"
              />
              <path
                class="threeCls-9"
                d="M504.44,764.57c.57,0,.88-.11,1.07-.22l-.19-.54c-.12.08-.34.17-.73.17-.42,0-.69-.22-.69-.75v-2.91h1.31v-.55h-1.31v-1.25h-.46l-.21,1.23-.71.13v.44h.71v2.94c0,.9.43,1.31,1.22,1.31h0Z"
              />
              <path
                class="threeCls-9"
                d="M508.65,763.27c0,.4-.32.75-.99.75-.55,0-1.01-.23-1.3-.53l-.42.51c.3.31.89.6,1.68.6,1.15,0,1.7-.7,1.7-1.36,0-1.62-2.41-1.19-2.41-2.26,0-.38.29-.71.94-.71.37,0,.75.16.97.39l.44-.47c-.29-.31-.82-.51-1.39-.51-1.04,0-1.63.64-1.63,1.32,0,1.61,2.41,1.18,2.41,2.26h0Z"
              />
              <path
                class="threeCls-9"
                d="M490.35,770.97l.97,4.06h.92l1.28-4.76h-.66l-.67,2.62c-.13.5-.25,1.02-.37,1.54h-.04c-.1-.48-.2-.91-.31-1.35l-.7-2.81h-.88l-.72,2.81c-.11.44-.21.88-.31,1.35h-.04c-.11-.53-.23-1.02-.36-1.53l-.67-2.63h-.7l1.26,4.76h.92l1.01-4.06h.04Z"
              />
              <path
                class="threeCls-9"
                d="M496.79,773.92c-.22.32-.65.65-1.19.65s-.86-.34-.86-.76c0-.72.9-1,2.05-.95v1.07h0ZM495.8,770.2c-.99,0-1.44.55-1.6.78l.5.39c.14-.23.45-.58,1.09-.58s1.01.23,1.01,1.01v.52c-1.69-.03-2.72.49-2.72,1.54,0,.65.49,1.27,1.37,1.27.81,0,1.19-.38,1.42-.64h.03c.11.32.39.58.87.58.09,0,.18-.02.24-.05v-.5h-.12c-.33,0-.46-.29-.46-.72v-2.15c0-1-.6-1.44-1.62-1.44h0Z"
              />
              <path
                class="threeCls-9"
                d="M501.34,773.77c0,.4-.32.75-.99.75-.55,0-1.01-.23-1.3-.53l-.42.51c.3.31.89.6,1.68.6,1.15,0,1.7-.7,1.7-1.36,0-1.62-2.41-1.19-2.41-2.26,0-.38.29-.71.94-.71.37,0,.75.16.97.39l.44-.47c-.29-.31-.82-.51-1.39-.51-1.04,0-1.63.64-1.63,1.32,0,1.61,2.41,1.18,2.41,2.26h0Z"
              />
              <path
                class="threeCls-9"
                d="M505.34,770.19c-.81,0-1.23.44-1.37.6h-.03v-2.41h-.68v6.64h.68v-3.4c.17-.41.61-.84,1.27-.84s.96.45.96,1.05v3.19h.68v-3.29c0-.97-.59-1.55-1.51-1.55h0Z"
              />
              <path
                class="threeCls-9"
                d="M510.65,770.23c-.11-.03-.26-.04-.48-.04-.55,0-.99.26-1.2.6h-.03l-.15-.53h-.52v4.76h.67v-3.55c.23-.43.71-.61,1.17-.61.18,0,.36.02.53.07v-.71h0Z"
              />
              <path
                class="threeCls-9"
                d="M511.88,772.61c0-1.23.34-1.84,1.24-1.84s1.3.62,1.3,1.9-.33,1.85-1.25,1.85-1.3-.63-1.3-1.91h0ZM513.12,775.11c1.44,0,2-1.02,2-2.49s-.5-2.43-1.95-2.43-2,1.01-2,2.48.5,2.45,1.94,2.45h0Z"
              />
              <path
                class="threeCls-9"
                d="M516.77,772.61c0-1.23.34-1.84,1.24-1.84s1.3.62,1.3,1.9-.33,1.85-1.25,1.85-1.3-.63-1.3-1.91h0ZM518.02,775.11c1.44,0,2-1.02,2-2.49s-.5-2.43-1.95-2.43-2,1.01-2,2.48.5,2.45,1.94,2.45h0Z"
              />
              <path
                class="threeCls-9"
                d="M524.45,770.93h-.04c-.17-.43-.55-.75-1.26-.75-.74,0-1.1.4-1.23.6h-.03l-.14-.51h-.53v4.76h.68v-3.41c.1-.41.48-.85,1.08-.85s.95.41.95,1.16v3.09h.68v-3.46c.12-.39.5-.8,1.09-.8s.94.38.94,1.11v3.14h.67v-3.28c0-1.04-.53-1.58-1.47-1.58-.74,0-1.21.37-1.39.75h0Z"
              />
            </g>
          </g>
          <path
            class="threeCls-8"
            d="M515.49,742.74h-53.8v-49.84h77.79v40.95l-21.6.31M516.82,742.92l-7.87-.32-7.87.35-7.87-.24-7.87.29-7.87-.47-7.87.49-8.21-.52.39,6.97-.34,6.74.57,6.74-.72,6.74.63,6.74-.34,6.74.32,6.62,10.94.28,11.11-.29,11.11.19,11.11-.23,11.11.19,11.11-.2,11.44-.28-.43-6.18.48-6.11-.42-4.55.03-6.56.47-5.89-.78-5.56.82-5.13-.68-6.61-1.14-.36-1.32.31-2.64.25-2.64.02-1.32-.52"
          />
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  class="threeCls-9"
                  d="M868.27,218.61c-.49,0-.89-.39-.9-.89l-.05-3.46c0-.26.1-.51.3-.68l2.38-2.13c.19-.17.44-.25.7-.23l2.09.22,1.63-.21c.36-.05.72.13.9.45l1.74,3.08,1.85-1.13c.42-.26.98-.13,1.24.3.26.43.13.98-.3,1.24l-2.65,1.62c-.21.13-.46.17-.7.1-.24-.06-.44-.22-.56-.43l-1.9-3.37-1.13.14c-.07,0-.14,0-.21,0l-1.8-.19-1.77,1.59.05,3.05c0,.5-.39.91-.89.91h-.01Z"
                />
                <path
                  class="threeCls-9"
                  d="M874.53,208.72c0,1.12-.91,2.02-2.02,2.02s-2.02-.91-2.02-2.02.91-2.02,2.02-2.02,2.02.91,2.02,2.02h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M869.93,229.83c-.05,0-.1,0-.16-.01-.56-.09-.95-.61-.86-1.18l1.54-10.07c.05-.3.22-.57.48-.73.26-.16.58-.19.87-.1l6.1,2.04c.47.16.76.62.69,1.11l-.54,4.09c-.07.57-.59.96-1.16.89s-.96-.59-.89-1.16l.43-3.25-4.13-1.38-1.35,8.86c-.08.51-.52.88-1.02.88h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M874.63,220.29h-4.2c-.1,0-.19-.08-.19-.19v-8.69c0-.1.08-.19.19-.19h4.2c.1,0,.18.08.18.19v8.69c0,.1-.08.19-.18.19h0Z"
                />
                <polygon
                  class="threeCls-9"
                  points="887.91 222.36 880.56 222.36 881.55 225.93 873.89 225.93 874.88 229.5 866.81 229.5 866.81 231.51 878.04 231.51 877.05 227.95 884.71 227.95 883.72 224.38 888.47 224.38 887.91 222.36 887.91 222.36"
                />
              </g>
              <g>
                <path
                  class="threeCls-9"
                  d="M844.08,227.91c-.74,0-1.23-.3-1.57-.58l-.41.56c.35.32.99.65,1.92.65,1.31,0,2.05-.77,2.05-1.7,0-1.89-2.92-1.59-2.92-3.01,0-.56.43-.96,1.15-.96.52,0,.89.18,1.2.42l.43-.54c-.35-.29-.89-.52-1.58-.52-1.1,0-1.9.72-1.9,1.65,0,1.93,2.92,1.62,2.92,3.01,0,.57-.45,1.02-1.28,1.02h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M848.59,228.49c.57,0,.88-.11,1.07-.22l-.19-.54c-.12.08-.34.17-.73.17-.42,0-.69-.22-.69-.75v-2.91h1.31v-.55h-1.31v-1.25h-.46l-.21,1.23-.71.13v.44h.71v2.94c0,.9.43,1.31,1.22,1.31h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M853.02,227.34c-.22.32-.65.65-1.19.65s-.86-.34-.86-.76c0-.72.9-1,2.05-.95v1.07h0ZM852.03,223.62c-.99,0-1.44.55-1.6.78l.5.39c.14-.23.45-.58,1.09-.58s1.01.23,1.01,1.01v.52c-1.69-.03-2.72.49-2.72,1.54,0,.65.49,1.27,1.37,1.27.81,0,1.19-.38,1.42-.64h.03c.11.32.39.58.87.58.09,0,.18-.02.24-.05v-.5h-.12c-.33,0-.46-.29-.46-.72v-2.15c0-1-.6-1.44-1.62-1.44h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M855.56,228.45h.68v-4.76h-.68v4.76h0ZM855.37,222.31c0,.28.22.49.49.49.29,0,.51-.21.51-.49s-.22-.5-.51-.5c-.27,0-.49.21-.49.5h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M860.24,223.65c-.11-.03-.26-.04-.48-.04-.55,0-.99.26-1.2.6h-.03l-.15-.53h-.52v4.76h.67v-3.55c.23-.43.71-.61,1.17-.61.18,0,.36.02.53.07v-.71h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M863.19,227.19c0,.4-.32.75-.99.75-.55,0-1.01-.23-1.3-.53l-.42.51c.3.31.89.6,1.68.6,1.15,0,1.7-.7,1.7-1.36,0-1.62-2.41-1.19-2.41-2.26,0-.38.29-.71.94-.71.37,0,.75.16.97.39l.44-.47c-.29-.31-.82-.51-1.39-.51-1.04,0-1.63.64-1.63,1.32,0,1.61,2.41,1.18,2.41,2.26h0Z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  class="threeCls-9"
                  d="M557.47,577.07c0-.49.39-.89.89-.9l3.46-.05c.26,0,.51.1.68.3l2.13,2.38c.17.19.25.44.23.7l-.22,2.09.21,1.63c.05.36-.13.72-.45.9l-3.08,1.74,1.13,1.85c.26.42.13.98-.3,1.24-.43.26-.98.13-1.24-.3l-1.62-2.65c-.13-.21-.17-.46-.1-.7.06-.24.22-.44.43-.56l3.37-1.9-.14-1.13c0-.07,0-.14,0-.21l.19-1.8-1.59-1.77-3.05.05c-.5,0-.91-.39-.91-.89h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M567.36,583.33c-1.12,0-2.02-.91-2.02-2.02s.91-2.02,2.02-2.02,2.02.91,2.02,2.02-.91,2.02-2.02,2.02h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M546.25,578.73c0-.05,0-.1.01-.16.09-.56.61-.95,1.18-.86l10.07,1.54c.3.05.57.22.73.48.16.26.19.58.1.87l-2.04,6.1c-.16.47-.62.76-1.11.69l-4.09-.54c-.57-.07-.96-.59-.89-1.16.08-.57.59-.96,1.16-.89l3.25.43,1.38-4.13-8.86-1.35c-.51-.08-.88-.52-.88-1.02h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M555.79,583.43v-4.2c0-.1.08-.19.19-.19h8.69c.1,0,.19.08.19.19v4.2c0,.1-.08.18-.19.18h-8.69c-.1,0-.19-.08-.19-.18h0Z"
                />
                <polygon
                  class="threeCls-9"
                  points="553.72 596.71 553.72 589.36 550.15 590.35 550.15 582.69 546.59 583.68 546.59 575.61 544.57 575.61 544.57 586.84 548.14 585.85 548.14 593.51 551.7 592.52 551.7 597.27 553.72 596.71 553.72 596.71"
                />
              </g>
              <g>
                <path
                  class="threeCls-9"
                  d="M546.95,606.3c0-.74.3-1.23.58-1.57l-.56-.41c-.32.35-.65.99-.65,1.92,0,1.31.77,2.05,1.7,2.05,1.89,0,1.59-2.92,3.01-2.92.56,0,.96.43.96,1.15,0,.52-.18.89-.42,1.2l.54.43c.29-.35.52-.89.52-1.58,0-1.1-.72-1.9-1.65-1.9-1.93,0-1.62,2.92-3.01,2.92-.57,0-1.02-.45-1.02-1.28h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M546.37,610.81c0,.57.11.88.22,1.07l.54-.19c-.08-.12-.17-.34-.17-.73,0-.42.22-.69.75-.69h2.91v1.31h.55v-1.31h1.25v-.46l-1.23-.21-.13-.71h-.44v.71h-2.94c-.9,0-1.31.43-1.31,1.22h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M547.52,615.24c-.32-.22-.65-.65-.65-1.19s.34-.86.76-.86c.72,0,1,.9.95,2.05h-1.07ZM551.24,614.25c0-.99-.55-1.44-.78-1.6l-.39.5c.23.14.58.45.58,1.09s-.23,1.01-1.01,1.01h-.52c.03-1.69-.49-2.72-1.54-2.72-.65,0-1.27.49-1.27,1.37,0,.81.38,1.19.64,1.42v.03c-.32.11-.58.39-.58.87,0,.09.02.18.05.24h.5v-.12c0-.33.29-.46.72-.46h2.15c1,0,1.44-.6,1.44-1.62h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M546.41,617.78v.68h4.76v-.68h-4.76ZM552.55,617.58c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M551.21,622.46c.03-.1.04-.26.04-.48,0-.55-.26-.99-.6-1.2v-.03l.53-.15v-.52h-4.76v.67h3.54c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71Z"
                />
                <path
                  class="threeCls-9"
                  d="M547.67,625.41c-.4,0-.75-.32-.75-.99,0-.55.23-1.01.53-1.3l-.51-.42c-.31.3-.6.89-.6,1.68,0,1.15.7,1.7,1.36,1.7,1.62,0,1.19-2.41,2.26-2.41.38,0,.71.29.71.94,0,.37-.16.75-.39.97l.47.44c.31-.29.51-.82.51-1.39,0-1.04-.64-1.63-1.32-1.63-1.61,0-1.18,2.41-2.26,2.41h0Z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  class="threeCls-9"
                  d="M586.89,595.8c-.23,0-.44.07-.61.17-.68.45-.52,1.5.24,1.79l.15.06c1.76.66,3.62,1,5.49,1h2.47c.47,0,.85-.38.85-.85v-1.51c0-.38-.31-.69-.69-.69l-7.92.03h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M588.8,590.28c0,1.42-1.15,2.57-2.58,2.57s-2.57-1.15-2.57-2.57,1.15-2.58,2.57-2.58,2.58,1.15,2.58,2.58h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M587.51,599.79l-3.52-2.37v-4.21c0-.23-.07-.44-.18-.61-.11-.23-.27-.44-.48-.6-.73-.57-1.78-.44-2.34.29l-4.58,5.88c-.06.08-.11.16-.16.25-.12.2-.19.43-.19.68v12.11c0,.73.59,1.31,1.31,1.31s1.31-.59,1.31-1.31v-10.66c.13-.09.25-.2.36-.34l2.66-3.41v1.23c0,.38.19.74.51.95l4.02,2.71c.2.13.42.2.64.2.37,0,.73-.18.95-.51.35-.52.22-1.24-.31-1.59h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M591.39,592.58h0c-.17-.07-.26-.26-.19-.44.07-.17.26-.26.43-.19.17.07.26.26.19.43-.05.13-.18.21-.31.21-.04,0-.08,0-.12-.02h0ZM590.32,592.84c-.14-.12-.16-.33-.04-.47.12-.14.33-.16.47-.04.14.12.16.33.05.47-.07.08-.16.12-.26.12-.08,0-.15-.03-.21-.08h0ZM592.09,593.19h0c-.12-.14-.09-.35.05-.47.14-.11.35-.09.47.05h0c.11.14.09.35-.05.47-.06.05-.13.07-.21.07-.1,0-.2-.04-.26-.12h0ZM589.72,593.78c-.16-.1-.2-.3-.11-.46.1-.16.3-.2.46-.11.16.1.2.31.11.46-.06.1-.17.15-.29.15-.06,0-.12-.02-.18-.05h0ZM592.68,594.07c-.09-.16-.04-.36.12-.46.16-.09.37-.04.46.12.09.16.04.36-.12.45-.05.03-.11.04-.17.04-.12,0-.23-.06-.29-.17h0ZM589.19,594.76c-.16-.09-.22-.29-.14-.45.09-.16.29-.22.45-.14.16.09.22.29.14.45-.06.11-.18.18-.3.18-.05,0-.11-.01-.16-.04h0ZM593.19,595.04h0c-.08-.17-.02-.37.15-.45.17-.08.37-.02.45.15.08.17.02.37-.15.45-.05.02-.1.03-.15.03-.12,0-.24-.07-.3-.19h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M586.89,595.8c-.23,0-.44.07-.61.17-.68.45-.52,1.5.24,1.79l.15.06c1.76.66,3.62,1,5.49,1h2.47c.47,0,.85-.38.85-.85v-1.51c0-.38-.31-.69-.69-.69l-7.92.03h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M588.8,590.28c0,1.42-1.15,2.57-2.58,2.57s-2.57-1.15-2.57-2.57,1.15-2.58,2.57-2.58,2.58,1.15,2.58,2.58h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M587.51,599.79l-3.52-2.37v-4.21c0-.23-.07-.44-.18-.61-.11-.23-.27-.44-.48-.6-.73-.57-1.78-.44-2.34.29l-4.58,5.88c-.06.08-.11.16-.16.25-.12.2-.19.43-.19.68v12.11c0,.73.59,1.31,1.31,1.31s1.31-.59,1.31-1.31v-10.66c.13-.09.25-.2.36-.34l2.66-3.41v1.23c0,.38.19.74.51.95l4.02,2.71c.2.13.42.2.64.2.37,0,.73-.18.95-.51.35-.52.22-1.24-.31-1.59h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M591.39,592.58h0c-.17-.07-.26-.26-.19-.44.07-.17.26-.26.43-.19.17.07.26.26.19.43-.05.13-.18.21-.31.21-.04,0-.08,0-.12-.02h0ZM590.32,592.84c-.14-.12-.16-.33-.04-.47.12-.14.33-.16.47-.04.14.12.16.33.05.47-.07.08-.16.12-.26.12-.08,0-.15-.03-.21-.08h0ZM592.09,593.19h0c-.12-.14-.09-.35.05-.47.14-.11.35-.09.47.05h0c.11.14.09.35-.05.47-.06.05-.13.07-.21.07-.1,0-.2-.04-.26-.12h0ZM589.72,593.78c-.16-.1-.2-.3-.11-.46.1-.16.3-.2.46-.11.16.1.2.31.11.46-.06.1-.17.15-.29.15-.06,0-.12-.02-.18-.05h0ZM592.68,594.07c-.09-.16-.04-.36.12-.46.16-.09.37-.04.46.12.09.16.04.36-.12.45-.05.03-.11.04-.17.04-.12,0-.23-.06-.29-.17h0ZM589.19,594.76c-.16-.09-.22-.29-.14-.45.09-.16.29-.22.45-.14.16.09.22.29.14.45-.06.11-.18.18-.3.18-.05,0-.11-.01-.16-.04h0ZM593.19,595.04h0c-.08-.17-.02-.37.15-.45.17-.08.37-.02.45.15.08.17.02.37-.15.45-.05.02-.1.03-.15.03-.12,0-.24-.07-.3-.19h0Z"
                />
              </g>
              <g>
                <path
                  class="threeCls-9"
                  d="M584.42,620.38v1.6c0,1.88,1.13,2.69,3.12,2.69s3.01-.83,3.01-2.68v-1.61h-6.14ZM589.93,621.08v.85c0,1.3-.64,2.02-2.47,2.02s-2.43-.63-2.43-1.98v-.89h4.89Z"
                />
                <path
                  class="threeCls-9"
                  d="M589.22,628.31c.03-.1.04-.26.04-.48,0-.55-.26-.99-.6-1.2v-.03l.53-.15v-.52h-4.76v.67h3.54c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71Z"
                />
                <path
                  class="threeCls-9"
                  d="M584.42,629.32v.68h4.76v-.68h-4.76ZM590.56,629.13c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M587.7,635.22c1.06-.03,1.58-.6,1.58-1.55,0-.74-.43-1.23-.6-1.36v-.03l.5-.14v-.52h-4.76v.68h3.41c.46.17.85.62.85,1.21,0,.67-.4,1.02-1.13,1.02h-3.12v.68h3.28Z"
                />
                <path
                  class="threeCls-9"
                  d="M591.06,637.33v-.68h-6.64v.68h6.64ZM586.86,637.46l-2.44,1.79v.87l2.46-1.86h.03l2.27,1.76v-.85l-2.28-1.71h-.03Z"
                />
                <path
                  class="threeCls-9"
                  d="M584.42,641.26v.68h4.76v-.68h-4.76ZM590.56,641.07c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M587.7,647.16c1.06-.03,1.58-.6,1.58-1.55,0-.74-.43-1.23-.6-1.36v-.03l.5-.14v-.52h-4.76v.68h3.41c.46.17.85.62.85,1.21,0,.67-.4,1.02-1.13,1.02h-3.12v.68h3.28Z"
                />
                <path
                  class="threeCls-9"
                  d="M588.98,652.01c.14-.29.24-.75.24-1.36,0-1.58-1.02-2.32-2.55-2.32-1.62,0-2.23.83-2.23,1.81,0,.61.24,1.02.38,1.16v.03h-.44c-.85,0-1.27-.35-1.27-1.22,0-.64.21-1.02.45-1.25l-.54-.39c-.19.19-.51.67-.51,1.57,0,1.19.62,1.96,1.87,1.96h4.6ZM588.5,651.33h-2.99c-.3-.23-.46-.63-.46-1.01,0-.67.36-1.3,1.72-1.3,1.26,0,1.86.61,1.86,1.53,0,.31-.05.58-.13.78h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M577.98,622.9l-4.06.97v.92l4.76,1.28v-.66l-2.62-.67c-.5-.13-1.02-.25-1.54-.37v-.04c.48-.1.91-.2,1.35-.31l2.81-.7v-.88l-2.81-.72c-.44-.11-.88-.21-1.35-.31v-.04c.53-.11,1.02-.23,1.53-.36l2.63-.67v-.7l-4.76,1.26v.92l4.06,1.01v.04h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M575.03,629.36c-.32-.22-.65-.65-.65-1.19s.34-.86.76-.86c.72,0,1,.9.95,2.05h-1.07ZM578.75,628.37c0-.99-.55-1.44-.78-1.6l-.39.5c.23.14.58.45.58,1.09s-.23,1.01-1.01,1.01h-.52c.03-1.69-.49-2.72-1.54-2.72-.65,0-1.27.49-1.27,1.37,0,.81.38,1.19.64,1.42v.03c-.32.11-.58.39-.58.87,0,.09.02.18.05.24h.5v-.12c0-.33.29-.46.72-.46h2.15c1,0,1.44-.6,1.44-1.62h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M573.87,633.04c0,.57.11.88.22,1.07l.54-.19c-.08-.12-.17-.34-.17-.73,0-.42.22-.69.75-.69h2.91v1.31h.55v-1.31h1.25v-.46l-1.23-.21-.13-.71h-.44v.71h-2.94c-.9,0-1.31.43-1.31,1.22h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M574.81,638.04c-.17-.2-.36-.63-.36-1.1,0-.95.45-1.45,1.62-1.51v3.03c.31.03.59.05.82.05,1.13,0,1.86-.6,1.86-1.73,0-1.06-.71-2.02-2.43-2.02s-2.47.74-2.47,2.09c0,.68.19,1.18.43,1.5l.53-.31h0ZM578.17,636.72c0,.77-.45,1.12-1.27,1.12-.06,0-.17,0-.27,0v-2.39c1.15.06,1.54.66,1.54,1.28h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M578.71,642.14c.03-.11.04-.26.04-.48,0-.55-.26-.99-.6-1.2v-.03l.53-.15v-.52h-4.76v.67h3.55c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71Z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  class="threeCls-15"
                  d="M574.33,670.55s.02-.03.1-.04c0,0,.08,0,.09,0h5.89c.4,0,.29.01.32.09v3.76s-6.38,0-6.38,0c-.08-.08-.03.03-.06-.1v-.37c0-.4-.07-3.14.04-3.32h0ZM573.32,668.22c0,2.93-.01,5.88-.01,8.82s-.07,5.95,0,8.87h8.32s0-17.54,0-17.54c.04-.7-.42-1.27-.74-1.57-.59-.54-.86-.47-1.75-.58v-1.88c.4-.05.58.04.97-.1.27-.09.61-.14.83-.29v-1.27c-1.58-.42-.15-.26-2.06-.31v-1.07s-2.5-.01-2.5-.01v.93c-1.97.05-.85-.25-2.68,1.21-.23.18-.5.4-.7.61-.56.56-.78.51-1.06,1.56-.22.82-.19,1.59-.17,2.49h.94c.15-1.71,0-1.5,1.07-2.46.32-.28.6-.58.9-.87.4-.4.51-.61,1.28-.45v1.91c-.57.09-1.03-.12-1.8.49-.32.25-.83.87-.82,1.51h0Z"
                />
                <path
                  class="threeCls-15"
                  d="M595.49,679.43v-2.62c-.36-.15-.81-.27-1.2-.42-1.2-.49-2.16-1.1-3.11-1.89-.77-.65-1.7-1.82-2.27-2.73-.2-.33-.39-.73-.61-1.05-.15,1,.29,2.54.61,3.34.72,1.79,2.03,3.35,3.58,4.36.59.38,2.06,1.1,2.99,1.02h0Z"
                />
                <path
                  class="threeCls-15"
                  d="M587.08,666.58c.16.26.9.59,1.77,2.27,1.1,2.11,2.06,5.33,4.34,5.71.48.08,1.37.07,1.75-.17-.55-.36-1.08-.19-2.07-1.89-1.14-1.95-1.83-5.5-4.02-6.03-.73-.17-1.14-.02-1.77.11h0Z"
                />
                <path
                  class="threeCls-15"
                  d="M586.21,678.01c3.22.17,4.62,5.31,7.68,4.1.23-.09.41-.19.59-.3.21-.13.33-.24.49-.35-1.04-.36-1.54-.66-2.22-1.28-1.62-1.5-3.29-3.81-5.49-2.87-.3.13-.93.47-1.05.7h0Z"
                />
                <path
                  class="threeCls-15"
                  d="M595.49,685.96v-2.69c-.77.01-1.05.21-2.25.07-1.81-.22-3.73-1.07-4.82-2.29-.01.55.6,1.75.86,2.15,1.23,1.88,3.84,3.43,6.22,2.77h0Z"
                />
                <path
                  class="threeCls-15"
                  d="M595.49,672.57v-2.67c-.55-.44-.38-.17-1.18-.91-1.17-1.09-1.8-2.71-1.84-4.48l-.05.06c-.16.26-.28.78-.33,1.08-.09.45-.11.93-.09,1.4.04.88.25,1.73.54,2.45.34.82.67,1.29,1.14,1.85.25.3,1.17,1.19,1.82,1.22h0Z"
                />
              </g>
              <g>
                <polygon
                  class="threeCls-9"
                  points="584.42 690.2 587.05 690.2 587.05 692.42 587.68 692.42 587.68 690.2 589.93 690.2 589.93 692.73 590.56 692.73 590.56 689.49 584.42 689.49 584.42 690.2 584.42 690.2"
                />
                <path
                  class="threeCls-9"
                  d="M584.42,693.93v.68h4.76v-.68h-4.76ZM590.56,693.74c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M589.22,698.62c.03-.11.04-.26.04-.48,0-.55-.26-.99-.6-1.2v-.03l.53-.15v-.52h-4.76v.67h3.54c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71Z"
                />
                <path
                  class="threeCls-9"
                  d="M585.31,702.42c-.17-.2-.36-.63-.36-1.1,0-.95.45-1.44,1.62-1.51v3.03c.31.03.59.05.82.05,1.13,0,1.86-.6,1.86-1.73,0-1.06-.71-2.02-2.43-2.02s-2.47.74-2.47,2.09c0,.68.19,1.18.43,1.5l.53-.31h0ZM588.67,701.1c0,.77-.45,1.12-1.27,1.12-.06,0-.17,0-.27,0v-2.39c1.15.06,1.54.66,1.54,1.28h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M574.81,692.42c-.17-.2-.36-.63-.36-1.1,0-.95.45-1.45,1.62-1.51v3.03c.31.03.59.05.82.05,1.13,0,1.86-.6,1.86-1.73,0-1.06-.71-2.02-2.43-2.02s-2.47.74-2.47,2.09c0,.68.19,1.18.43,1.5l.53-.31h0ZM578.17,691.1c0,.77-.45,1.12-1.27,1.12-.06,0-.17,0-.27,0v-2.39c1.15.06,1.54.66,1.54,1.28h0Z"
                />
                <polygon
                  class="threeCls-9"
                  points="573.92 696.66 573.92 697.45 576.38 695.92 578.68 697.36 578.68 696.57 576.91 695.55 576.91 695.52 578.68 694.45 578.68 693.66 576.39 695.11 573.92 693.57 573.92 694.37 575.85 695.48 575.85 695.52 573.92 696.66 573.92 696.66"
                />
                <path
                  class="threeCls-9"
                  d="M573.87,699.71c0,.57.11.88.22,1.07l.54-.19c-.08-.12-.17-.34-.17-.73,0-.42.22-.69.75-.69h2.91v1.31h.55v-1.31h1.25v-.46l-1.23-.21-.13-.71h-.44v.71h-2.94c-.9,0-1.31.43-1.31,1.22h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M573.92,701.91v.68h4.76v-.68h-4.76ZM580.06,701.72c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M577.2,707.81c1.06-.03,1.58-.6,1.58-1.55,0-.74-.43-1.23-.6-1.36v-.03l.5-.14v-.52h-4.76v.68h3.41c.46.17.85.62.85,1.21,0,.67-.4,1.02-1.13,1.02h-3.12v.68h3.28Z"
                />
                <path
                  class="threeCls-9"
                  d="M578.48,712.66c.14-.29.24-.75.24-1.36,0-1.58-1.02-2.32-2.55-2.32-1.62,0-2.23.83-2.23,1.81,0,.61.24,1.02.38,1.16v.03h-.44c-.85,0-1.27-.35-1.27-1.22,0-.64.21-1.02.45-1.25l-.54-.39c-.19.19-.51.67-.51,1.57,0,1.19.62,1.96,1.87,1.96h4.6ZM578,711.98h-2.99c-.3-.23-.46-.63-.46-1.01,0-.67.36-1.3,1.72-1.3,1.26,0,1.86.61,1.86,1.53,0,.31-.05.58-.13.78h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M575.42,714.08c-1.09.03-1.6.57-1.6,1.55,0,.8.41,1.22.59,1.36v.04l-.5.13v.53h4.76v-.68h-3.12c-.75-.02-1.15-.52-1.15-1.2s.38-1.04,1.16-1.04h3.12v-.68h-3.26Z"
                />
                <path
                  class="threeCls-9"
                  d="M573.92,719.37v.68h4.76v-.68h-4.76ZM580.06,719.18c-.28,0-.49.22-.49.49,0,.29.21.51.49.51s.5-.22.5-.51c0-.27-.21-.49-.5-.49h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M575.18,723.91c-.4,0-.75-.32-.75-.99,0-.55.23-1.01.53-1.3l-.51-.42c-.31.3-.6.89-.6,1.68,0,1.15.7,1.7,1.36,1.7,1.62,0,1.19-2.41,2.26-2.41.38,0,.71.29.71.94,0,.37-.16.75-.39.97l.47.44c.31-.29.51-.82.51-1.39,0-1.04-.64-1.63-1.32-1.63-1.61,0-1.18,2.41-2.26,2.41h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M578.76,727.91c0-.81-.44-1.23-.6-1.37v-.03h2.41v-.68h-6.64v.68h3.4c.41.17.84.61.84,1.27s-.45.96-1.05.96h-3.19v.68h3.29c.97,0,1.55-.59,1.55-1.51h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M574.81,733.87c-.17-.2-.36-.63-.36-1.1,0-.95.45-1.44,1.62-1.51v3.03c.31.03.59.05.82.05,1.13,0,1.86-.6,1.86-1.73,0-1.06-.71-2.02-2.43-2.02s-2.47.74-2.47,2.09c0,.68.19,1.18.43,1.5l.53-.31h0ZM578.17,732.55c0,.77-.45,1.12-1.27,1.12-.06,0-.17,0-.27,0v-2.39c1.15.06,1.54.66,1.54,1.28h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M578.71,737.98c.03-.11.04-.26.04-.48,0-.55-.26-.99-.6-1.2v-.03l.53-.15v-.52h-4.76v.67h3.55c.43.23.61.71.61,1.17,0,.18-.02.36-.07.53h.71Z"
                />
              </g>
            </g>
            <g>
              <path
                class="threeCls-15"
                d="M259.51,540.09c-.84-.22-1.47.46-1.62,1.08-.21.88.35,1.58.98,1.75,1.78.49,2.43-2.35.64-2.83h0ZM258.2,546.95l.35-.43c.18-.19.33-.55.57-.67.14.15.11.18.21.37l.54,1.03c.09.31.47.83.53,1.09.05.19-.33.95-.42,1.17l-2.43,5.76c-.12.29-.42.9-.46,1.15,1.51.1,1.68.06,2.11-.85.3-.63.63-1.34.93-1.98.23-.48,1.76-3.8,1.9-3.95.18.56.29,1.53.42,2.18.07.36.12.7.22,1.05.11.39.25.55.68.6h5.15c-.05-.25-.37-.88-.48-1.14-.21-.46-.26-.64-.89-.66-.95-.03-2.19.08-3.09-.02-.15-.9-.35-3.12-.63-3.8-.22-.53-.45-1.04-.66-1.54-.56-1.33-.86-1.65-.19-1.66h1.33c.13.27,1.25,2.25,1.52,2.35.37.13.73-.17.81-.43.11-.34-.17-.69-.32-.96-.34-.64-1.04-2.15-1.48-2.34-.32-.14-2.03-.07-2.52-.07-1.88,0-2.66-.29-3.76,1.39-.21.31-.79,1.39-1,1.53-.11,0-.11-.05-.09.04-.42.03-1.13.06-1.56,0v-7.04c1.05.07,2.42,0,3.52,0l3.43-.02s.03,0,.04-.01c0-.01.02,0,.03-.02l4.28.02v12.22c1.28.16,1.12-.25,1.69.92.17.34.77,1.45.81,1.74h-2.45c-.05.38-.08,2.43.05,2.63.09.14.51.55.66.71.11.12.56.58.61.69-2.23.09-4.96,0-7.3,0-.65,0-.45.08-.96-.49-.34-.38-.49-.65-.82-.67-.46-.02-.99,0-1.45,0,.06.17,0,.09.12.23l.36.38c.13.14.39.4.47.51-.38.05-1.26.03-1.67.02-.28-.01-.33-.18-.48-.35-.13-.14-.25-.26-.39-.41-.61-.63-.55-.51-.55-1.11.01-2.74-.06-5.54,0-8.26.56-.04,1.31.05,1.82-.02.48-.06.58-.59.89-.86h0Z"
              />
              <g>
                <polygon
                  class="threeCls-9"
                  points="277.02 550.88 277.02 550.26 274.34 550.26 274.34 548.08 276.59 548.08 276.59 547.46 274.34 547.46 274.34 545.37 276.9 545.37 276.9 544.74 273.64 544.74 273.64 550.88 277.02 550.88 277.02 550.88"
                />
                <path
                  class="threeCls-9"
                  d="M281.39,546.77h-.04c-.17-.43-.55-.75-1.26-.75-.74,0-1.1.4-1.23.6h-.03l-.14-.51h-.53v4.76h.68v-3.41c.1-.41.48-.85,1.08-.85s.95.41.95,1.16v3.09h.68v-3.46c.12-.39.5-.8,1.09-.8s.94.38.94,1.11v3.14h.67v-3.28c0-1.04-.53-1.58-1.47-1.58-.74,0-1.21.37-1.39.75h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M288.7,549.99c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM287.38,546.63c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M292.81,546.08c-.11-.03-.26-.04-.48-.04-.55,0-.99.26-1.2.6h-.03l-.15-.53h-.52v4.76h.67v-3.55c.23-.43.71-.61,1.17-.61.18,0,.36.02.53.07v-.71h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M297.01,546.32c-.29-.14-.75-.24-1.36-.24-1.58,0-2.32,1.02-2.32,2.55,0,1.62.83,2.23,1.81,2.23.61,0,1.02-.24,1.16-.38h.03v.44c0,.85-.35,1.27-1.22,1.27-.64,0-1.02-.21-1.25-.45l-.39.54c.19.19.67.51,1.57.51,1.19,0,1.96-.62,1.96-1.87v-4.6h0ZM296.34,546.8v2.99c-.23.3-.63.46-1.01.46-.67,0-1.3-.36-1.3-1.72,0-1.26.61-1.86,1.53-1.86.31,0,.58.05.78.13h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M301.49,549.99c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM300.17,546.63c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M306.81,547.6c-.03-1.06-.6-1.58-1.55-1.58-.74,0-1.23.43-1.36.6h-.03l-.14-.5h-.52v4.76h.68v-3.41c.17-.46.62-.85,1.21-.85.67,0,1.02.4,1.02,1.13v3.12h.68v-3.28h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M307.99,548.57c0,1.72.76,2.39,1.93,2.39.81,0,1.22-.29,1.41-.51l-.42-.47c-.19.22-.49.38-.93.38-.8,0-1.29-.52-1.29-1.87s.52-1.84,1.29-1.84c.46,0,.74.19.94.39l.46-.5c-.18-.2-.6-.5-1.36-.5-1.16,0-2.02.78-2.02,2.53h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M311.81,552.62c.11.04.31.09.54.09.97,0,1.44-.6,1.74-1.5l1.68-5.09h-.71l-.74,2.34c-.31.98-.41,1.38-.49,1.73h-.03c-.11-.41-.25-.88-.53-1.73l-.77-2.34h-.74l1.72,4.93c-.21.74-.53,1.05-1.13,1.05-.13,0-.32-.03-.45-.08l-.11.6h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M322.21,549.99c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM320.89,546.63c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
                />
                <polygon
                  class="threeCls-9"
                  points="326.46 550.88 327.25 550.88 325.71 548.42 327.16 546.12 326.36 546.12 325.35 547.89 325.31 547.89 324.24 546.12 323.45 546.12 324.91 548.4 323.37 550.88 324.16 550.88 325.28 548.94 325.31 548.94 326.46 550.88 326.46 550.88"
                />
                <path
                  class="threeCls-9"
                  d="M328.37,550.88h.68v-4.76h-.68v4.76h0ZM328.17,544.73c0,.28.22.49.49.49.29,0,.51-.21.51-.49s-.22-.5-.51-.5c-.27,0-.49.21-.49.5h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M332.03,550.92c.57,0,.88-.11,1.07-.22l-.19-.54c-.12.08-.34.17-.73.17-.42,0-.69-.22-.69-.75v-2.91h1.31v-.55h-1.31v-1.25h-.46l-.21,1.23-.71.13v.44h.71v2.94c0,.9.43,1.31,1.22,1.31h0Z"
                />
              </g>
              <polygon
                class="threeCls-9"
                points="234.73 548.45 234.73 562.61 230.18 559.28 228.43 561.66 236.2 567.35 236.2 567.35 236.2 567.35 243.97 561.66 242.23 559.28 237.68 562.61 237.68 548.45 249.65 548.45 249.65 545.5 234.73 545.5 234.73 548.45 234.73 548.45 234.73 548.45"
              />
            </g>
            <g>
              <g>
                <polygon
                  class="threeCls-9"
                  points="622.76 471.56 622.76 470.94 620.08 470.94 620.08 468.76 622.33 468.76 622.33 468.14 620.08 468.14 620.08 466.05 622.64 466.05 622.64 465.42 619.38 465.42 619.38 471.56 622.76 471.56 622.76 471.56"
                />
                <path
                  class="threeCls-9"
                  d="M627.13,467.46h-.04c-.17-.43-.55-.75-1.26-.75-.74,0-1.1.4-1.23.6h-.03l-.14-.51h-.53v4.76h.68v-3.41c.1-.41.48-.85,1.08-.85s.95.41.95,1.16v3.09h.68v-3.46c.12-.39.5-.8,1.09-.8s.94.38.94,1.11v3.14h.67v-3.28c0-1.04-.53-1.58-1.47-1.58-.74,0-1.21.37-1.39.75h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M634.44,470.67c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM633.12,467.31c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M638.55,466.76c-.11-.03-.26-.04-.48-.04-.55,0-.99.26-1.2.6h-.03l-.15-.53h-.52v4.76h.67v-3.54c.23-.43.71-.61,1.17-.61.18,0,.36.02.53.07v-.71h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M642.75,467c-.29-.14-.75-.24-1.36-.24-1.58,0-2.32,1.02-2.32,2.55,0,1.62.83,2.23,1.81,2.23.61,0,1.02-.24,1.16-.38h.03v.44c0,.85-.35,1.27-1.22,1.27-.64,0-1.02-.21-1.25-.45l-.39.54c.19.19.67.51,1.57.51,1.19,0,1.96-.62,1.96-1.87v-4.6h0ZM642.08,467.48v2.99c-.23.3-.63.46-1.01.46-.67,0-1.3-.36-1.3-1.72,0-1.26.61-1.86,1.53-1.86.31,0,.58.05.78.13h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M647.23,470.67c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM645.91,467.31c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M652.56,468.28c-.03-1.06-.6-1.58-1.55-1.58-.74,0-1.23.43-1.36.6h-.03l-.14-.5h-.52v4.76h.68v-3.41c.17-.46.62-.85,1.21-.85.67,0,1.02.4,1.02,1.13v3.12h.68v-3.28h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M653.73,469.25c0,1.72.76,2.39,1.93,2.39.81,0,1.22-.29,1.41-.51l-.42-.47c-.19.22-.49.38-.93.38-.8,0-1.29-.52-1.29-1.87s.52-1.84,1.29-1.84c.46,0,.74.19.94.39l.46-.5c-.18-.2-.6-.5-1.36-.5-1.16,0-2.02.78-2.02,2.53h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M657.55,473.3c.11.04.31.09.54.09.97,0,1.44-.6,1.74-1.5l1.68-5.09h-.71l-.74,2.34c-.31.98-.41,1.38-.49,1.73h-.03c-.11-.41-.25-.88-.53-1.73l-.77-2.34h-.74l1.72,4.93c-.21.74-.53,1.05-1.13,1.05-.13,0-.32-.03-.45-.08l-.11.6h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M667.95,470.67c-.2.17-.63.36-1.1.36-.95,0-1.44-.45-1.51-1.62h3.03c.03-.31.05-.59.05-.82,0-1.13-.6-1.86-1.73-1.86-1.06,0-2.02.71-2.02,2.43s.74,2.47,2.09,2.47c.68,0,1.18-.19,1.5-.43l-.31-.53h0ZM666.63,467.31c.77,0,1.12.45,1.12,1.27,0,.06,0,.17,0,.27h-2.39c.06-1.15.66-1.54,1.28-1.54h0Z"
                />
                <polygon
                  class="threeCls-9"
                  points="672.2 471.56 672.99 471.56 671.45 469.1 672.9 466.8 672.1 466.8 671.09 468.57 671.05 468.57 669.98 466.8 669.2 466.8 670.65 469.08 669.11 471.56 669.9 471.56 671.02 469.63 671.05 469.63 672.2 471.56 672.2 471.56"
                />
                <path
                  class="threeCls-9"
                  d="M674.11,471.56h.68v-4.76h-.68v4.76h0ZM673.91,465.42c0,.28.22.49.49.49.29,0,.51-.21.51-.49s-.22-.5-.51-.5c-.27,0-.49.21-.49.5h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M677.77,471.6c.57,0,.88-.11,1.07-.22l-.19-.54c-.12.08-.34.17-.73.17-.42,0-.69-.22-.69-.75v-2.91h1.31v-.55h-1.31v-1.25h-.46l-.21,1.23-.71.13v.44h.71v2.94c0,.9.43,1.31,1.22,1.31h0Z"
                />
              </g>
              <g>
                <path
                  class="threeCls-15"
                  d="M605.25,460.78c-.84-.22-1.47.46-1.62,1.08-.21.88.35,1.58.98,1.75,1.78.49,2.43-2.35.64-2.83h0ZM603.94,467.63l.35-.43c.18-.19.33-.55.57-.67.14.15.11.18.21.37l.54,1.03c.09.31.47.83.53,1.09.05.19-.33.95-.42,1.17l-2.43,5.76c-.12.29-.42.9-.46,1.15,1.51.1,1.68.06,2.11-.85.3-.63.63-1.34.93-1.98.23-.48,1.76-3.8,1.9-3.95.18.56.29,1.53.42,2.18.07.36.12.7.22,1.05.11.39.25.55.68.6h5.15c-.05-.25-.37-.88-.48-1.14-.21-.46-.26-.64-.89-.66-.95-.03-2.19.08-3.09-.02-.15-.9-.35-3.12-.63-3.8-.22-.53-.45-1.04-.66-1.54-.56-1.33-.86-1.65-.19-1.67h1.33c.13.27,1.25,2.25,1.52,2.35.37.13.73-.17.81-.43.11-.34-.17-.69-.32-.96-.34-.64-1.04-2.15-1.48-2.34-.32-.14-2.03-.07-2.52-.07-1.88,0-2.66-.29-3.76,1.39-.21.31-.79,1.39-1,1.53-.11,0-.11-.05-.09.04-.42.03-1.13.06-1.56,0v-7.04c1.05.07,2.42,0,3.52,0l3.43-.02s.03,0,.04-.01c0-.01.02,0,.03-.02l4.28.02v12.22c1.28.16,1.12-.25,1.69.92.17.34.77,1.45.81,1.74h-2.45c-.05.38-.08,2.43.05,2.63.09.14.51.55.66.71.11.12.56.58.61.69-2.23.09-4.96,0-7.3,0-.65,0-.45.08-.96-.49-.34-.38-.49-.65-.82-.67-.46-.02-.99,0-1.45,0,.06.17,0,.09.12.23l.36.38c.13.14.39.4.47.51-.38.05-1.26.03-1.67.02-.28-.01-.33-.18-.48-.35-.13-.14-.25-.26-.39-.41-.61-.63-.55-.51-.55-1.11.01-2.74-.06-5.54,0-8.26.56-.04,1.31.05,1.82-.02.48-.06.58-.59.89-.86h0Z"
                />
                <polygon
                  class="threeCls-9"
                  points="580.47 469.13 580.47 483.29 575.92 479.96 574.17 482.34 581.94 488.03 581.94 488.03 581.94 488.03 589.71 482.34 587.97 479.96 583.42 483.29 583.42 469.13 595.39 469.13 595.39 466.18 580.47 466.18 580.47 469.13 580.47 469.13 580.47 469.13"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  class="threeCls-9"
                  d="M635.04,750.56c0,1.24-1.01,2.25-2.25,2.25s-2.25-1.01-2.25-2.25,1.01-2.25,2.25-2.25,2.25,1.01,2.25,2.25h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M638.75,761.45l-1.55-6.68c-.05-.75-.79-1.34-1.68-1.34h-5.45c-.9,0-1.63.59-1.68,1.34l-1.54,6.68c-.1.42.22.82.72.9.5.08.97-.19,1.07-.61l1.56-6.74s0-.02,0-.04h.32l-1.91,9.9c-.03.16.02.32.15.44.12.12.3.19.49.19h1.43v6.85c0,.42.41.77.91.77s.91-.34.91-.77v-6.85h.63v6.85c0,.42.41.77.91.77s.91-.34.91-.77v-6.85h1.43c.36,0,.65-.25.65-.55,0-.06,0-.11-.03-.16l-1.9-9.83h.32s0,.03,0,.04l1.56,6.74c.08.37.46.62.89.62.06,0,.12,0,.18-.01.49-.08.81-.48.72-.9h0Z"
                />
              </g>
              <g>
                <polygon
                  class="threeCls-9"
                  points="603.44 768.8 603.44 774.94 606.43 774.94 606.43 774.32 604.07 774.32 604.07 768.8 603.44 768.8 603.44 768.8"
                />
                <path
                  class="threeCls-9"
                  d="M609.4,773.83c-.2.32-.58.65-1.07.65s-.77-.34-.77-.76c0-.72.81-1,1.83-.95v1.07h0ZM608.52,770.11c-.89,0-1.28.55-1.43.78l.45.39c.13-.23.4-.58.97-.58s.9.23.9,1.01v.52c-1.51-.03-2.43.49-2.43,1.54,0,.65.44,1.27,1.23,1.27.72,0,1.07-.38,1.27-.64h.03c.1.32.35.58.78.58.08,0,.16-.02.22-.05v-.5h-.11c-.3,0-.42-.29-.42-.72v-2.15c0-1-.54-1.44-1.45-1.44h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M613.94,770.26c-.2-.04-.43-.08-.68-.08-1.2,0-2.02.87-2.02,2.59,0,1.56.61,2.27,1.57,2.27.56,0,.95-.3,1.11-.58h.03l.13.48h.45v-6.64h-.6v1.96h0ZM612.95,774.45c-.56,0-1.09-.43-1.09-1.76s.49-1.92,1.43-1.92c.2,0,.49.05.65.11v2.79c-.16.45-.49.77-.99.77h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M616.05,774.94h.61v-4.76h-.61v4.76h0ZM615.88,768.79c0,.28.2.49.44.49.26,0,.45-.21.45-.49s-.2-.5-.45-.5c-.24,0-.44.21-.44.5h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M620.82,774.05c-.18.17-.56.36-.99.36-.85,0-1.29-.45-1.35-1.62h2.71c.03-.31.05-.59.05-.82,0-1.13-.54-1.86-1.55-1.86-.95,0-1.81.71-1.81,2.43s.66,2.47,1.87,2.47c.61,0,1.06-.19,1.34-.43l-.27-.53h0ZM619.63,770.68c.69,0,1,.45,1,1.27,0,.06,0,.17,0,.27h-2.14c.05-1.15.59-1.54,1.14-1.54h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M624.36,773.68c0,.4-.29.75-.88.75-.49,0-.9-.23-1.16-.53l-.38.51c.27.31.8.6,1.5.6,1.03,0,1.52-.7,1.52-1.36,0-1.62-2.15-1.19-2.15-2.26,0-.38.26-.71.84-.71.33,0,.67.16.87.39l.39-.47c-.26-.31-.74-.51-1.24-.51-.93,0-1.46.64-1.46,1.32,0,1.61,2.15,1.18,2.15,2.26h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M605.7,781.38l.87,4.06h.82l1.14-4.76h-.59l-.6,2.62c-.12.5-.23,1.02-.33,1.54h-.03c-.09-.48-.18-.91-.27-1.35l-.63-2.81h-.78l-.64,2.81c-.1.44-.19.88-.27,1.35h-.03c-.09-.53-.2-1.02-.32-1.53l-.6-2.63h-.63l1.13,4.76h.82l.91-4.06h.03Z"
                />
                <path
                  class="threeCls-9"
                  d="M611.46,784.33c-.2.32-.58.65-1.06.65s-.77-.34-.77-.76c0-.72.81-1,1.83-.95v1.07h0ZM610.58,780.61c-.89,0-1.28.55-1.43.78l.45.39c.12-.23.4-.58.97-.58s.9.23.9,1.01v.52c-1.51-.03-2.43.49-2.43,1.54,0,.65.44,1.27,1.23,1.27.72,0,1.07-.38,1.27-.64h.03c.1.32.35.58.78.58.08,0,.16-.02.22-.05v-.5h-.11c-.3,0-.41-.29-.41-.72v-2.15c0-1-.54-1.44-1.45-1.44h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M615.53,784.18c0,.4-.29.75-.88.75-.49,0-.9-.23-1.16-.53l-.38.51c.27.31.8.6,1.5.6,1.03,0,1.52-.7,1.52-1.36,0-1.62-2.15-1.19-2.15-2.26,0-.38.26-.71.84-.71.33,0,.67.16.87.39l.39-.47c-.26-.31-.74-.51-1.24-.51-.93,0-1.46.64-1.46,1.32,0,1.61,2.15,1.18,2.15,2.26h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M619.11,780.6c-.72,0-1.1.44-1.23.6h-.03v-2.41h-.61v6.64h.61v-3.4c.15-.41.55-.84,1.13-.84s.86.45.86,1.05v3.19h.61v-3.29c0-.97-.52-1.55-1.35-1.55h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M623.86,780.65c-.09-.03-.24-.04-.43-.04-.49,0-.88.26-1.07.6h-.03l-.13-.53h-.46v4.76h.6v-3.54c.2-.43.64-.61,1.05-.61.16,0,.32.02.48.07v-.71h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M624.96,783.02c0-1.23.31-1.84,1.11-1.84s1.17.62,1.17,1.9-.3,1.85-1.12,1.85-1.16-.63-1.16-1.91h0ZM626.07,785.52c1.29,0,1.79-1.02,1.79-2.49s-.45-2.43-1.75-2.43-1.78,1.01-1.78,2.48.45,2.45,1.74,2.45h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M629.34,783.02c0-1.23.31-1.84,1.11-1.84s1.17.62,1.17,1.9-.3,1.85-1.12,1.85-1.16-.63-1.16-1.91h0ZM630.45,785.52c1.29,0,1.79-1.02,1.79-2.49s-.45-2.43-1.75-2.43-1.78,1.01-1.78,2.48.45,2.45,1.74,2.45h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M636.2,781.34h-.03c-.16-.43-.49-.75-1.13-.75-.66,0-.99.4-1.1.6h-.03l-.13-.51h-.47v4.76h.61v-3.41c.09-.41.43-.85.96-.85s.85.41.85,1.16v3.09h.61v-3.46c.11-.39.45-.8.98-.8s.84.38.84,1.11v3.14h.6v-3.28c0-1.04-.47-1.58-1.32-1.58-.66,0-1.08.37-1.24.75h0Z"
                />
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  class="threeCls-9"
                  d="M569.2,781.27c-.1-.1-.26-.1-.36,0l-.76.76v-2.87c0-.14-.12-.25-.26-.25s-.26.11-.26.25v2.87l-.75-.76c-.1-.1-.26-.1-.36,0-.1.1-.1.26,0,.36l1.16,1.16s.06.05.1.06c.03.01.07.02.11.02s.07,0,.11-.02c.04-.01.07-.03.1-.06l1.16-1.16c.1-.1.1-.26,0-.36h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M569.2,775.38l-1.16-1.16s-.07-.05-.1-.06c-.03-.02-.07-.02-.11-.02s-.08,0-.11.02c-.04.01-.07.03-.1.06l-1.16,1.16c-.1.1-.1.26,0,.36.05.05.12.08.18.08s.13-.02.18-.08l.75-.76v2.87c0,.14.11.26.26.26s.26-.11.26-.26v-2.87l.76.76c.05.05.11.08.18.08s.13-.02.18-.08c.1-.1.1-.26,0-.36h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M546.96,767.03c-.38,0-.7.31-.7.7v21.55c0,.38.31.7.7.7h16.2c.38,0,.7-.31.7-.7v-21.55c0-.38-.31-.7-.7-.7h-16.2ZM563.16,790.91h-16.2c-.9,0-1.63-.73-1.63-1.63v-21.55c0-.9.73-1.63,1.63-1.63h16.2c.9,0,1.63.73,1.63,1.63v21.55c0,.9-.73,1.63-1.63,1.63h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M556.85,771.52c0,.99-.8,1.79-1.79,1.79s-1.79-.8-1.79-1.79.8-1.79,1.79-1.79,1.79.8,1.79,1.79h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M557.23,773.8h-4.34c-.74,0-1.34.51-1.34,1.14v5.36c0,.34.32.61.72.61s.72-.27.72-.61v-5.28h.37v14.09c0,.34.32.61.72.61s.72-.27.72-.61v-7.76h.5v7.76c0,.34.32.61.72.61s.72-.27.72-.61v-14.09h.37v5.28c0,.34.32.61.72.61s.72-.27.72-.61v-5.36c0-.63-.6-1.14-1.34-1.14h0Z"
                />
              </g>
              <g>
                <path
                  class="threeCls-9"
                  d="M596.01,781.28c-.1-.1-.26-.1-.36,0l-.76.76v-2.87c0-.14-.12-.25-.26-.25s-.26.11-.26.25v2.87l-.75-.76c-.1-.1-.26-.1-.36,0-.1.1-.1.26,0,.36l1.16,1.16s.06.05.1.06c.03.01.07.02.11.02s.07,0,.11-.02c.04-.01.07-.03.1-.06l1.16-1.16c.1-.1.1-.26,0-.36h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M596.01,775.39l-1.16-1.16s-.07-.05-.1-.06c-.03-.02-.07-.02-.11-.02s-.08,0-.11.02c-.04.01-.07.03-.1.06l-1.16,1.16c-.1.1-.1.26,0,.36.05.05.12.08.18.08s.13-.02.18-.08l.75-.76v2.87c0,.14.11.26.26.26s.26-.11.26-.26v-2.87l.76.76c.05.05.11.08.18.08s.13-.02.18-.08c.1-.1.1-.26,0-.36h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M573.77,767.04c-.38,0-.7.31-.7.7v21.55c0,.38.31.7.7.7h16.2c.38,0,.7-.31.7-.7v-21.55c0-.38-.31-.7-.7-.7h-16.2ZM589.97,790.92h-16.2c-.9,0-1.63-.73-1.63-1.63v-21.55c0-.9.73-1.63,1.63-1.63h16.2c.9,0,1.63.73,1.63,1.63v21.55c0,.9-.73,1.63-1.63,1.63h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M583.66,771.53c0,.99-.8,1.79-1.79,1.79s-1.79-.8-1.79-1.79.8-1.79,1.79-1.79,1.79.8,1.79,1.79h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M584.04,773.81h-4.34c-.74,0-1.34.51-1.34,1.14v5.36c0,.34.32.61.72.61s.72-.27.72-.61v-5.28h.37v14.09c0,.34.32.61.72.61s.72-.27.72-.61v-7.76h.5v7.76c0,.34.32.61.72.61s.72-.27.72-.61v-14.09h.37v5.28c0,.34.32.61.72.61s.72-.27.72-.61v-5.36c0-.63-.6-1.14-1.34-1.14h0Z"
                />
              </g>
            </g>
            <g>
              <polygon
                class="threeCls-9"
                points="562.23 755.63 562.23 761.77 565.57 761.77 565.57 761.14 562.93 761.14 562.93 755.63 562.23 755.63 562.23 755.63"
              />
              <path
                class="threeCls-9"
                d="M566.66,761.77h.68v-4.76h-.68v4.76h0ZM566.47,755.62c0,.28.22.49.49.49.29,0,.51-.21.51-.49s-.22-.5-.51-.5c-.27,0-.49.21-.49.5h0Z"
              />
              <path
                class="threeCls-9"
                d="M571.37,755.15c-.18-.06-.4-.11-.74-.11-.93,0-1.36.51-1.36,1.24v.72h-.8v.53h.79v4.23h.68v-4.23h1.24v-.53h-1.23v-.73c0-.43.17-.64.63-.64.27,0,.46.03.64.09l.14-.58h0Z"
              />
              <path
                class="threeCls-9"
                d="M573.47,761.81c.57,0,.88-.11,1.07-.22l-.19-.54c-.12.08-.34.17-.73.17-.42,0-.69-.22-.69-.75v-2.91h1.31v-.55h-1.31v-1.25h-.46l-.21,1.23-.71.13v.44h.71v2.94c0,.9.43,1.31,1.22,1.31h0Z"
              />
            </g>
          </g>
        </g>
        <g>
          <polygon
            class="threeCls-10"
            points="836.97 456.2 830.87 456.39 824.89 456.13 818.91 456.31 812.93 456.1 806.96 456.44 800.98 456.09 795.23 456.46 794.96 462.3 795.2 468.3 794.8 474.31 795.31 480.32 794.87 486.33 795.1 492.33 794.88 498.43 800.98 498.22 806.96 498.43 812.93 498.29 818.91 498.46 824.89 498.32 830.87 498.46 836.78 498.29 837.18 492.33 836.77 486.33 836.86 480.32 836.62 474.31 836.91 468.3 836.49 462.3 836.97 456.2 836.97 456.2"
          />
          <g>
            <polygon
              class="threeCls-7"
              points="836.97 456.2 830.87 456.39 824.89 456.13 818.91 456.31 812.93 456.1 806.96 456.44 800.98 456.09 795.23 456.46 794.96 462.3 795.2 468.3 794.8 474.31 795.31 480.32 794.87 486.33 795.1 492.33 794.88 498.43 800.98 498.22 806.96 498.43 812.93 498.29 818.91 498.46 824.89 498.32 830.87 498.46 836.78 498.29 837.18 492.33 836.77 486.33 836.86 480.32 836.62 474.31 836.91 468.3 836.49 462.3 836.97 456.2 836.97 456.2"
            />
            <path
              class="threeCls-12"
              d="M818.53,473c0-.3-4.28-4.24-6.53-1.07-.48.67-1.58,2.23-1.63,3.58-.05,1.28,1.69,1.84,2.19,2.65,1.31,2.13,2.91.89,4.58-.11,1.13-.68,2.66-.21,2.75-2.54.05-1.39-1.42.07-1.36-2.51h0Z"
            />
            <path
              class="threeCls-12"
              d="M833.12,490.23c-7.49-10.95-6.23,6.47.27,2.84.76-.43.19-2.18-.27-2.84h0Z"
            />
            <path
              class="threeCls-12"
              d="M824.18,462.6c1.13-1.89,4.4.02,6.7.91,1.87.73,2.94.17,2.88,1.43-.06,1.19.02,5.47-4.42,5.76-1.43.09-3.72-2.44-6.11-2.73-3.92-.48.52-4.66.95-5.37h0Z"
            />
            <path
              class="threeCls-12"
              d="M801,459.33c14.28-2.87-4.03,18.05-2.7,3.35.04-.38,2.22-3.25,2.7-3.35h0Z"
            />
            <path
              class="threeCls-12"
              d="M819.28,486.11c7.08-3.65.19,12.57-3.67,5.81-1.74-3.05,1.62-4.75,3.67-5.81h0Z"
            />
            <path
              class="threeCls-12"
              d="M805.72,491.57c6.56,4.53-11.01,6.08-6.85-.5,1.88-2.97,4.96-.81,6.85.5h0Z"
            />
            <path
              class="threeCls-12"
              d="M800.46,479.1c-6.65,11.48,8.53,2.84,2.45-1.46-.71-.5-2.05.77-2.45,1.46h0Z"
            />
          </g>
        </g>
        <g>
          <polygon
            class="threeCls-10"
            points="521.87 521.71 527.92 521.9 533.85 521.65 539.78 521.82 545.7 521.61 551.63 521.95 557.56 521.6 563.25 521.97 563.52 527.76 563.28 533.71 563.68 539.67 563.18 545.63 563.61 551.58 563.38 557.54 563.6 563.58 557.56 563.38 551.63 563.59 545.7 563.45 539.78 563.61 533.85 563.48 527.92 563.62 522.06 563.45 521.66 557.54 522.06 551.58 521.98 545.63 522.22 539.67 521.93 533.71 522.34 527.76 521.87 521.71 521.87 521.71"
          />
          <g>
            <polygon
              class="threeCls-7"
              points="521.87 521.71 527.92 521.9 533.85 521.65 539.78 521.82 545.7 521.61 551.63 521.95 557.56 521.6 563.25 521.97 563.52 527.76 563.28 533.71 563.68 539.67 563.18 545.63 563.61 551.58 563.38 557.54 563.6 563.58 557.56 563.38 551.63 563.59 545.7 563.45 539.78 563.61 533.85 563.48 527.92 563.62 522.06 563.45 521.66 557.54 522.06 551.58 521.98 545.63 522.22 539.67 521.93 533.71 522.34 527.76 521.87 521.71 521.87 521.71"
            />
            <path
              class="threeCls-12"
              d="M540.15,538.13c0-.3,4.24-4.21,6.47-1.06.47.66,1.57,2.21,1.62,3.55.05,1.26-1.68,1.83-2.18,2.63-1.3,2.11-2.89.88-4.54-.11-1.12-.67-2.64-.2-2.72-2.52-.05-1.38,1.41.07,1.35-2.48h0Z"
            />
            <path
              class="threeCls-12"
              d="M525.68,555.22c7.43-10.85,6.18,6.42-.26,2.82-.76-.42-.19-2.16.26-2.82h0Z"
            />
            <path
              class="threeCls-12"
              d="M534.55,527.82c-1.12-1.87-4.36.02-6.64.9-1.85.72-2.92.17-2.86,1.42.06,1.18-.02,5.42,4.39,5.71,1.41.09,3.68-2.42,6.05-2.71,3.89-.48-.52-4.62-.94-5.32h0Z"
            />
            <path
              class="threeCls-12"
              d="M557.53,524.58c-14.16-2.84,4,17.9,2.68,3.32-.03-.38-2.21-3.22-2.68-3.32h0Z"
            />
            <path
              class="threeCls-12"
              d="M539.4,551.13c-7.02-3.62-.19,12.47,3.64,5.76,1.72-3.03-1.61-4.71-3.64-5.76h0Z"
            />
            <path
              class="threeCls-12"
              d="M552.85,556.54c-6.5,4.49,10.91,6.03,6.79-.5-1.86-2.95-4.91-.8-6.79.5h0Z"
            />
            <path
              class="threeCls-12"
              d="M558.07,544.17c6.59,11.38-8.45,2.81-2.43-1.45.71-.5,2.03.76,2.43,1.45h0Z"
            />
          </g>
        </g>
        <g>
          <polygon
            class="threeCls-10"
            points="501.65 160.98 495.54 161.17 489.57 160.92 483.59 161.09 477.61 160.89 471.63 161.22 465.66 160.87 459.91 161.24 459.64 167.08 459.88 173.09 459.48 179.1 459.98 185.11 459.55 191.11 459.78 197.12 459.56 203.21 465.66 203.01 471.63 203.22 477.61 203.08 483.59 203.24 489.57 203.11 495.54 203.25 501.46 203.08 501.86 197.12 501.45 191.11 501.54 185.11 501.3 179.1 501.59 173.09 501.17 167.08 501.65 160.98 501.65 160.98"
          />
          <g>
            <polygon
              class="threeCls-7"
              points="459.49 161.31 465.55 161.49 471.47 161.24 477.4 161.42 483.33 161.21 489.25 161.54 495.18 161.2 500.87 161.56 501.14 167.35 500.91 173.31 501.3 179.27 500.8 185.22 501.24 191.18 501 197.13 501.22 203.18 495.18 202.97 489.25 203.18 483.33 203.04 477.4 203.2 471.47 203.07 465.55 203.21 459.68 203.04 459.28 197.13 459.69 191.18 459.61 185.22 459.84 179.27 459.55 173.31 459.97 167.35 459.49 161.31 459.49 161.31"
            />
            <path
              class="threeCls-12"
              d="M482.81,186.44c0,.3-4.24,4.2-6.47,1.06-.47-.66-1.57-2.21-1.62-3.55-.05-1.26,1.68-1.83,2.18-2.63,1.3-2.11,2.89-.88,4.54.11,1.12.67,2.64.2,2.72,2.52.05,1.38-1.41-.07-1.35,2.48h0Z"
            />
            <path
              class="threeCls-12"
              d="M497.28,169.36c-7.43,10.85-6.18-6.42.26-2.82.76.42.19,2.16-.26,2.82h0Z"
            />
            <path
              class="threeCls-12"
              d="M488.41,196.75c1.12,1.87,4.36-.02,6.64-.9,1.85-.72,2.92-.17,2.86-1.42-.06-1.18.02-5.42-4.39-5.71-1.41-.09-3.68,2.42-6.05,2.71-3.89.48.52,4.62.94,5.32h0Z"
            />
            <path
              class="threeCls-12"
              d="M465.43,199.99c14.16,2.84-4-17.9-2.68-3.32.03.38,2.21,3.22,2.68,3.32h0Z"
            />
            <path
              class="threeCls-12"
              d="M483.55,173.45c7.02,3.62.19-12.47-3.64-5.76-1.72,3.03,1.61,4.71,3.64,5.76h0Z"
            />
            <path
              class="threeCls-12"
              d="M470.11,168.03c6.5-4.49-10.91-6.03-6.79.5,1.86,2.95,4.91.8,6.79-.5h0Z"
            />
            <path
              class="threeCls-12"
              d="M464.89,180.4c-6.59-11.38,8.45-2.81,2.43,1.45-.71.5-2.03-.76-2.43-1.45h0Z"
            />
          </g>
        </g>
        <g>
          <polygon
            class="threeCls-10"
            points="773.49 118.94 767.38 119.13 761.41 118.88 755.43 119.05 749.45 118.84 743.47 119.18 737.5 118.83 731.75 119.2 731.48 125.04 731.72 131.05 731.32 137.05 731.82 143.06 731.39 149.07 731.62 155.08 731.4 161.17 737.5 160.97 743.47 161.18 749.45 161.04 755.43 161.2 761.41 161.07 767.38 161.21 773.3 161.04 773.7 155.08 773.29 149.07 773.38 143.06 773.14 137.05 773.43 131.05 773.01 125.04 773.49 118.94 773.49 118.94"
          />
          <g>
            <polygon
              class="threeCls-7"
              points="731.71 119.5 737.77 119.69 743.69 119.44 749.62 119.61 755.55 119.4 761.47 119.74 767.4 119.39 773.09 119.76 773.36 125.55 773.13 131.51 773.52 137.46 773.02 143.42 773.46 149.37 773.22 155.33 773.44 161.37 767.4 161.17 761.47 161.38 755.55 161.24 749.62 161.4 743.69 161.27 737.77 161.41 731.9 161.24 731.51 155.33 731.91 149.37 731.83 143.42 732.06 137.46 731.77 131.51 732.19 125.55 731.71 119.5 731.71 119.5"
            />
            <path
              class="threeCls-12"
              d="M750,144.64c0,.3,4.24,4.21,6.47,1.06.47-.66,1.57-2.21,1.62-3.55.05-1.26-1.68-1.83-2.18-2.63-1.3-2.11-2.89-.88-4.54.11-1.12.67-2.64.2-2.72,2.52-.05,1.38,1.41-.07,1.35,2.48h0Z"
            />
            <path
              class="threeCls-12"
              d="M735.53,127.55c7.43,10.85,6.18-6.42-.26-2.82-.76.42-.19,2.16.26,2.82h0Z"
            />
            <path
              class="threeCls-12"
              d="M744.4,154.95c-1.12,1.87-4.36-.02-6.64-.9-1.85-.72-2.92-.17-2.86-1.42.06-1.18-.02-5.42,4.39-5.71,1.41-.09,3.68,2.42,6.05,2.71,3.89.48-.52,4.62-.94,5.32h0Z"
            />
            <path
              class="threeCls-12"
              d="M767.38,158.19c-14.16,2.84,4-17.9,2.68-3.32-.03.38-2.21,3.22-2.68,3.32h0Z"
            />
            <path
              class="threeCls-12"
              d="M749.25,131.64c-7.02,3.62-.19-12.47,3.64-5.76,1.72,3.03-1.61,4.71-3.64,5.76h0Z"
            />
            <path
              class="threeCls-12"
              d="M762.7,126.23c-6.5-4.49,10.91-6.03,6.79.5-1.86,2.95-4.91.8-6.79-.5h0Z"
            />
            <path
              class="threeCls-12"
              d="M767.92,138.6c6.59-11.38-8.45-2.81-2.43,1.45.71.5,2.03-.76,2.43-1.45h0Z"
            />
          </g>
        </g>
        <g>
          <polygon
            class="threeCls-10"
            points="370.61 455.94 328.89 453.48 286.36 455.67 243.83 454.48 200.45 455.6 202.49 413.14 200.37 371.28 201.77 329.43 200.14 287.57 201.48 245.71 200.07 203.85 201.76 162.31 249.57 162.91 273.72 162.78 297.83 164.25 322 163.09 346.09 165.46 370.29 163.11 370.61 163.2 371.25 183.27 369.7 220.38 371.47 255.71 369.7 295.71 371.03 335.27 369.66 376.19 371.57 416.07 370.61 455.94"
          />
          <polyline
            class="threeCls-2"
            points="370.61 455.94 328.89 453.48 286.36 455.67 243.83 454.48 200.45 455.6 202.49 413.14 200.37 371.28 201.77 329.43 200.14 287.57 201.48 245.71 200.07 203.85 201.76 162.31 249.57 162.91 273.72 162.78 297.83 164.25 322 163.09 346.09 165.46 370.29 163.11 370.61 163.2"
          />
        </g>
        <g id="Tower">
          <g>
            <polyline
              class="threeCls-3"
              points="995.33 456.19 998.03 594.77 995.46 692.45 997.65 790.71 930.68 789.28 864.61 790.96 692.07 791.19"
            />
            <polyline
              class="threeCls-3"
              points="441.46 18.03 484.34 18.26 541.2 16.35 598.06 18.26 654.92 16.35 711.79 18.26 768.65 16.35 825.51 18.26 882.37 16.35 939.23 18.26 996.77 16.63 995.14 57.18 997.05 97.06 995.14 136.94 997.05 176.81 995.14 216.69 997.05 256.56 995.14 296.44 997.05 336.31 995.14 376.19 997.05 416.07 995.14 455.94"
            />
            <polyline
              class="threeCls-3"
              points="369.66 455.94 371.57 416.07 369.66 376.19 371.57 336.31 369.66 296.44 371.57 256.56 369.66 216.69 371.57 176.81 369.66 136.94 371.57 97.06 369.66 57.18 371.29 17.98 406.65 18.03"
            />
          </g>
          <g>
            <g>
              <path
                class="threeCls-13"
                d="M429.24,33.01c-.06-.79-.16-1.71-.39-2.54l-.05-.17-.2-.04c-.48-.11-.95-.14-1.46-.16.04-.03.07-.07.1-.11.07-.11.1-.23.1-.38,0-.12,0-.25-.07-.4l-.06-.13-.2-.03s-.02-.01-.02-.02c0-.84-.02-1.85-.03-2.9v-1.31s0-.02,0-.03c.12-.08.21-.19.26-.31.08-.21.09-.4,0-.57l-.07-.14-.2-.02s-.02-.01-.02-.03c-.01-1.48-.02-2.47-.01-3.13,0-.17.01-.38.02-.65,0-.01,0-.02,0-.02.11-.04.21-.09.29-.16.06-.05.12-.11.18-.19.03-.05.12-.2.05-.36l-.04-.09-.1-.04c-.13-.06-.27-.07-.39-.08v-.26c0-.4,0-.83,0-1.29,0-.81-.01-1.72-.01-2.57,0-.01,0-.02.01-.02.1-.04.18-.09.26-.13l.13-.07v-.13c0-.09,0-.18,0-.26,0-.1-.05-.18-.12-.23-.1-.08-.22-.09-.27-.09h0c.02-1.05.05-1.75.12-2.13v-.02c.08-.83.14-1.65.1-2.46,0-.04,0-.09,0-.14-.01-.26-.03-.64-.49-.9-.27-.11-.58-.14-.85-.16-.11,0-.21-.02-.33-.03h-.02c-.65-.05-1.35-.09-2.07-.09-.93,0-1.72.07-2.43.21l-.11.02-.07.07c-.13.13-.13.27-.13.34,0,.06,0,.11.01.15v.04c0,.47.1.94.18,1.39.04.21.08.43.11.64-.07.03-.12.06-.17.1-.23.18-.23.43-.22.59v.28s.26.02.26.02c.05,0,.1,0,.15,0,0,0,.02,0,.02,0,0,0,0,.01,0,.02l-.03.52c-.07,1.2-.12,2.29-.12,3.4,0,0,0,.01-.02.02-.21.1-.36.25-.44.42l-.05.13.06.08c0,.06.01.22.18.32.09.05.18.06.23.06h.04c0,.74.01,2.1.01,3.49,0,.01,0,.02-.02.03-.23.05-.42.15-.55.28-.09.09-.14.19-.15.3l-.02.15c-.01.09.01.17.07.22.09.1.22.11.27.11l.29.02s0,.04,0,.06l-.02.22.14.03v2.76s0,1.03,0,1.03c0,.01,0,.02-.01.02-.1.03-.19.08-.28.14-.1.08-.32.24-.32.48v.47h.28s.06,0,.11,0c0,0,.04,0,.05,0v.25s.17.02.17.02v.81s0,1.58,0,1.58c-.05.31.01.57.19.78,0,.01,0,.02,0,.03,0,.01-.02.01-.02.01-.35.02-.68.04-.98.07h-.03c-.21.02-.37.03-.48.04h-.06c-.19,0-.46.04-.63.18-.11.1-.16.22-.15.35,0,.11,0,.28,0,.46v.02c-.01.47-.02,1.05,0,1.33v.05c-.01.19-.02.5.23.67.06.04.17.1.33.1.02,0,.05,0,.07,0h9.89s-.02-.34-.02-.34ZM420.89,20.88s0,.02,0,.02c0,0,0,0-.02,0h-.04s.04-.03.07-.04h0ZM423.62,8.71c.58,0,1.17.03,1.75.08.1.02.23.03.36.04.14.01.44.04.5.06.06.03.06.22.07.34v.11c0,.1.01.2.02.3.01.17.02.32,0,.43-.07.3-.06.6-.06.89,0,.25.01.49-.03.71-.14.54-.11,1.08-.08,1.61,0,.07,0,.14.01.21,0,0,0,.01,0,.02,0,0,0,0-.02,0l-.28-.04s-.02-.01-.02-.03v-.08c0-.14-.11-.26-.25-.27l-.64-.08s-.09-.01-.14-.02l.3-.28-.59-.05c-.18-.02-.36-.04-.54-.06-.01,0-.02-.01-.02-.03v-.03c0-.14-.11-.26-.25-.28l-.67-.08s0-.02,0-.03l.05-.26-1.07-.12s-.02-.01-.02-.03v-.4s-.13,0-.13,0c-.02-.41-.09-.81-.17-1.25-.08-.43-.17-.87-.17-1.29.69-.07,1.39-.11,2.09-.11ZM426.18,29.43c0,.23,0,.44,0,.63-.01,0-.02,0-.03,0-.76-.04-1.56-.06-2.36-.06h-.25c-.29-.03-.59-.05-.88-.07-.32-.05-.87-.12-.93-.31-.02-.1-.02-.84-.03-1.25,0-.37,0-.63,0-.7v-.43c.13,0,.26.02.39.03.01,0,.02.01.02.03v.28s.25.03.25.03c.19.02.39.04.58.05.01,0,.02.01.02.02v.06c.02.13.13.23.26.24l.59.06s.02.01.02.03c0,.14.12.26.26.27l.58.04s.02,0,.02.02l.02.1c.02.12.12.22.24.23l.46.06s.01.07.02.1v.23s.27.02.27.02c.11,0,.23.02.35.04.02,0,.07.01.11.02l-.07.2.09.02ZM426.15,28.7c-.05,0-.11-.02-.16-.02-.01,0-.02,0-.02-.01-.02-.07-.05-.13-.08-.19l-.07-.12-.55-.07-.02-.1c-.01-.09-.06-.16-.12-.21-.09-.06-.19-.07-.23-.07l-.49-.03v-.02c0-.14-.12-.25-.25-.27l-.61-.06s-.02-.01-.02-.02l-.04-.31h-.25c-.17-.01-.35-.02-.52-.04-.01,0-.02-.01-.02-.03v-.26s-.24-.04-.24-.04c-.14-.02-.3-.04-.45-.06-.02,0-.03-.01-.02-.03,0-.15-.1-.27-.25-.29h-.03s-.02-.02-.02-.03c-.01-1.34-.02-2.76-.02-4.31.02,0,.05.02.07.02l.45.07s.02.01.02.03c0,.05,0,.1.01.16l.04.21.74.02s.04.09.08.14c.07.07.16.1.27.1.01,0,.03,0,.04,0,.04,0,.08,0,.13,0,.02,0,.05,0,.08,0,0,.04.01.1.05.15.09.13.25.14.3.15l.39.04-.27.23.63.05c.15.01.31.03.47.04l-.23.23.6.02c.15,0,.3.02.44.04,0,.08.01.2.14.29.04.03.09.05.13.06,0,.68-.01,2.29-.01,2.29,0,.8,0,1.57-.01,2.24-.01,0-.02,0-.03,0ZM426.07,23.34c-.1-.02-.19-.03-.29-.04-.04-.07-.09-.12-.17-.16-.13-.07-.27-.09-.4-.1l-.22-.02s-.02-.01-.02-.02c-.04-.06-.09-.12-.15-.16-.14-.09-.31-.11-.42-.12l-.19-.02c0-.05,0-.11-.05-.17-.07-.1-.18-.14-.27-.15-.05-.01-.11-.02-.17-.02-.05,0-.1,0-.14,0-.01,0-.02,0-.03,0v-.23s-.77-.02-.77-.02c0-.01,0-.03.01-.04l.09-.27-.82-.13h0s0-.14-.09-.23c-.08-.07-.17-.09-.21-.09l-.11-.02c0-1.24,0-2.59.02-4.11,0-.02.01-.02.03-.02h.06s.02.02.02.03v.12c.03.13.12.23.25.25l.73.11s.02.01.02.03v.02c0,.14.11.25.24.27l.7.1v.25s.81.12.81.12c0,0,.02.01.02.03.03.09.1.16.19.2.08.04.16.05.21.05l.44.05s.03.08.04.11l.06.13.16.03c.16.02.32.04.48.06l.08.09.02,1.32c-.01.61-.02,1.5-.03,2.8-.05-.01-.09-.03-.15-.03ZM425.36,13.85c.09.08.21.1.26.1l.38.05.02.09c.01.09.05.17.13.22.01,0,.02.01.03.02l.05,4.29s0,.02,0,.02c0,0,0,0-.02,0-.08,0-.16-.02-.25-.03,0-.01,0-.03,0-.04l-.02-.21-.77-.08.07-.21-.9-.13v-.25s-.94-.13-.94-.13c-.01,0-.02-.01-.02-.04,0-.14-.1-.25-.24-.27l-.74-.11s-.02-.01-.02-.02v-.13c-.03-.13-.13-.23-.26-.25l-.41-.05s-.02-.01-.02-.03v-.22c-.01-1.15.06-2.33.13-3.47.01-.23.03-.45.04-.67,0-.01.01-.02.03-.02l.6.06s.02.1.03.14l.05.16.8.1s.02.01.02.03v.26s.24.04.24.04c.17.03.35.05.52.07l.07.05c.04.07.1.14.18.19.16.1.35.12.48.14l.39.05v.04s0,.15.11.25ZM428.43,32.7s0,0-.02,0c-.87-.06-1.88-.07-2.67-.07-.35,0-.7,0-1.05,0-.34,0-.68,0-1.01,0-.45,0-.82,0-1.15,0-.15,0-.3,0-.45,0-.81,0-1.78.02-2.58.05,0-.02,0-.03,0-.04,0-.05,0-.1,0-.14-.03-.25-.05-.85-.06-1.7.03,0,.06,0,.11,0l.6-.03c.91-.04,2.01-.07,3.09-.07h.32c.95.07,1.84.1,2.7.11.02,0,.04,0,.07,0,.14,0,.25-.02.37-.07.65.01,1.14.04,1.51.09v.02c.09.55.21,1.23.24,1.83,0,0,0,.01,0,.02Z"
              />
              <polygon
                class="threeCls-1"
                points="426.98 2.39 421.13 2.39 415.57 4.2 410.84 7.63 407.4 12.37 405.59 17.93 405.59 23.78 407.4 29.34 410.84 34.07 415.57 37.51 421.13 39.31 426.98 39.31 432.54 37.51 437.27 34.07 440.71 29.34 442.52 23.78 442.52 17.93 440.71 12.37 437.27 7.63 432.54 4.2 426.98 2.39"
              />
            </g>
            <g>
              <polygon
                class="threeCls-9"
                points="407.62 56.82 408.79 56.82 408.79 47.63 411.5 47.63 411.5 46.59 404.89 46.59 404.89 47.63 407.62 47.63 407.62 56.82 407.62 56.82"
              />
              <path
                class="threeCls-9"
                d="M413.07,52.78c0-2.06.57-3.06,2.07-3.06s2.17,1.04,2.17,3.17-.55,3.08-2.09,3.08-2.16-1.05-2.16-3.18h0ZM415.15,56.95c2.41,0,3.34-1.71,3.34-4.16s-.83-4.06-3.25-4.06-3.33,1.68-3.33,4.13.83,4.09,3.24,4.09h0Z"
              />
              <path
                class="threeCls-9"
                d="M424.67,50.05l1.62,6.77h1.53l2.13-7.94h-1.09l-1.12,4.36c-.22.83-.42,1.71-.61,2.57h-.06c-.16-.8-.34-1.52-.51-2.25l-1.17-4.68h-1.46l-1.2,4.68c-.19.73-.35,1.47-.51,2.25h-.06c-.18-.87-.38-1.71-.6-2.55l-1.11-4.38h-1.17l2.1,7.94h1.53l1.69-6.77h.06Z"
              />
              <path
                class="threeCls-9"
                d="M436.39,55.33c-.34.29-1.05.6-1.84.6-1.59,0-2.41-.74-2.51-2.7h5.05c.06-.51.09-.98.09-1.37,0-1.88-1.01-3.11-2.89-3.11-1.77,0-3.37,1.18-3.37,4.06s1.23,4.11,3.49,4.11c1.14,0,1.97-.32,2.49-.71l-.51-.87h0ZM434.18,49.73c1.28,0,1.87.76,1.87,2.12,0,.1,0,.28-.01.45h-3.98c.1-1.91,1.09-2.57,2.13-2.57h0Z"
              />
              <path
                class="threeCls-9"
                d="M443.23,48.82c-.18-.04-.44-.07-.8-.07-.92,0-1.65.44-2,1.01h-.06l-.25-.88h-.86v7.94h1.12v-5.91c.38-.71,1.18-1.02,1.95-1.02.29,0,.6.03.89.12v-1.18h0Z"
              />
            </g>
          </g>
        </g>

        <g id="Dining_Hall" data-name="Dining Hall">
          <polygon
            class="threeCls-10"
            points="693.63 790.13 643.03 790.13 642.42 743.29 599.12 743.14 601.05 579.09 600.78 557.3 599.31 497.34 698.24 497.34 694.63 557.37 694.93 579.19 698.53 655.71 696.03 687.53 698.53 715.25 693.63 790.13"
          />

          <g>
            <g>
              <g>
                <path
                  class="threeCls-9"
                  d="M610.96,670.64h2.67c3.14,0,4.48-1.88,4.48-5.21s-1.39-5.02-4.46-5.02h-2.68v10.23h0ZM612.13,661.44h1.42c2.17,0,3.37,1.07,3.37,4.11s-1.05,4.04-3.3,4.04h-1.49v-8.16h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M620.59,670.64h1.14v-7.94h-1.14v7.94h0ZM620.27,660.39c0,.47.36.82.82.82.48,0,.85-.35.85-.82s-.36-.83-.85-.83c-.45,0-.82.35-.82.83h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M630.17,665.17c-.04-1.77-.99-2.63-2.58-2.63-1.24,0-2.04.72-2.26.99h-.06l-.23-.83h-.86v7.94h1.14v-5.68c.28-.77,1.04-1.42,2.01-1.42,1.11,0,1.71.67,1.71,1.88v5.21h1.14v-5.47h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M632.92,670.64h1.14v-7.94h-1.14v7.94h0ZM632.6,660.39c0,.47.36.82.82.82.48,0,.85-.35.85-.82s-.36-.83-.85-.83c-.45,0-.82.35-.82.83h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M642.76,665.17c-.04-1.77-.99-2.63-2.58-2.63-1.24,0-2.04.72-2.26.99h-.06l-.23-.83h-.86v7.94h1.14v-5.68c.28-.77,1.04-1.42,2.01-1.42,1.11,0,1.71.67,1.71,1.88v5.21h1.14v-5.47h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M650.84,663.04c-.48-.23-1.25-.41-2.26-.41-2.63,0-3.87,1.71-3.87,4.25,0,2.7,1.39,3.72,3.02,3.72,1.02,0,1.69-.41,1.94-.63h.06v.73c0,1.42-.58,2.11-2.03,2.11-1.07,0-1.69-.35-2.09-.74l-.66.9c.32.32,1.11.85,2.61.85,1.98,0,3.27-1.04,3.27-3.12v-7.66h0ZM649.72,663.84v4.99c-.38.5-1.05.77-1.68.77-1.12,0-2.17-.6-2.17-2.87,0-2.1,1.02-3.11,2.55-3.11.51,0,.96.09,1.3.22h0Z"
                />
                <polygon
                  class="threeCls-9"
                  points="663.74 660.41 663.74 664.95 658.79 664.95 658.79 660.41 657.62 660.41 657.62 670.64 658.79 670.64 658.79 665.98 663.74 665.98 663.74 670.64 664.9 670.64 664.9 660.41 663.74 660.41 663.74 660.41"
                />
                <path
                  class="threeCls-9"
                  d="M671.59,668.78c-.36.54-1.08,1.08-1.98,1.08s-1.43-.57-1.43-1.27c0-1.2,1.5-1.66,3.41-1.59v1.78h0ZM669.94,662.58c-1.65,0-2.39.92-2.67,1.3l.83.66c.23-.38.74-.96,1.81-.96s1.68.38,1.68,1.68v.86c-2.82-.04-4.54.82-4.54,2.57,0,1.08.82,2.12,2.29,2.12,1.34,0,1.98-.63,2.36-1.07h.06c.19.54.66.96,1.44.96.15,0,.31-.03.41-.09v-.83h-.2c-.55,0-.77-.48-.77-1.2v-3.59c0-1.66-1.01-2.41-2.7-2.41h0Z"
                />
                <path
                  class="threeCls-9"
                  d="M675.52,659.56v9.5c0,1.04.53,1.68,1.62,1.68.31,0,.7-.04.99-.17v-.96c-.15.07-.36.16-.66.16-.6,0-.83-.31-.83-1.01v-9.19h-1.12Z"
                />
                <path
                  class="threeCls-9"
                  d="M679.73,659.56v9.5c0,1.04.53,1.68,1.62,1.68.31,0,.7-.04.99-.17v-.96c-.15.07-.36.16-.66.16-.6,0-.83-.31-.83-1.01v-9.19h-1.12Z"
                />
              </g>
              <g>
                <path
                  class="threeCls-13"
                  d="M650.47,613.7c-1.23,0-2.44.26-3.61.77-5.25,2.27-7.4,9.53-5.82,14.5.85,2.96,3.57,4.88,5.69,5.97,1.33.63,2.75.95,4.22.95,2.88,0,5.76-1.3,7.71-3.47,1.87-2.08,2.73-4.73,2.44-7.48,0-5.89-5.08-11.24-10.64-11.24h0ZM650.54,637.37c-1.52,0-3.03-.33-4.48-.97-1.71-.79-2.99-1.78-3.79-2.96-2.11-3.01-3.15-5.86-3.2-8.73-.28-4.71,2.62-9.33,7.23-11.49,1.51-.71,3.1-1.08,4.72-1.08,3.09,0,6.17,1.36,8.44,3.73,2.35,2.44,3.62,5.74,3.49,9.04-.42,6.75-6.11,12.44-12.42,12.44h0Z"
                />
                <path
                  class="threeCls-13"
                  d="M650.77,630.27c-2.55-.36-4.83-2.44-5.31-4.83-.17-1.46.25-2.82,1.17-3.85,1-1.12,2.48-1.76,4.06-1.76.71,0,1.42.13,2.09.39,2.12.64,3.71,2.51,3.87,4.55.03.19-.03.38-.15.54-.12.16-.29.26-.49.28-.03,0-.07,0-.1,0-.21,0-.41-.09-.56-.26-.14-.16-.2-.37-.17-.58.24-1.71-1.26-3.02-2.75-3.51-.64-.23-1.31-.35-1.94-.35-1.11,0-2.09.36-2.82,1.03-1.3,1.17-1.69,3.16-.9,4.54.84,1.51,2.53,2.73,4.03,2.91h0c.29,0,.44.23.44.45,0,.11-.04.22-.11.3-.08.09-.2.14-.33.14h-.03Z"
                />
                <path
                  class="threeCls-13"
                  d="M665.83,636.99c-.23,0-.42-.12-.51-.32-.37-.94-.33-1.89-.29-2.82.02-.4.03-.82.02-1.23.04-1.86.14-4.31.22-6.48l.06-1.5c0-.37.02-.76.04-1.13.03-.7.06-1.42.01-2.13-.68-.22-1.2-.78-1.46-1.54-.68-1.66-.59-3.44-.5-5.15.03-.49.05-1.01.06-1.5,0-.13.11-.23.24-.23.07,0,.13.03.17.07.04.04.06.1.07.15.11.77.13,1.57.14,2.35.01.66.03,1.35.1,2,.16.04.36.06.57.06.18,0,.36-.01.52-.04.01-.27.02-.57,0-.87-.02-.54,0-1.09,0-1.62.01-.61.03-1.24,0-1.86,0-.1.03-.19.09-.26.07-.07.16-.11.27-.11s.19.04.26.1c.06.06.1.15.1.25.06,1.61.13,3.04.24,4.39.36.09.74.15,1.03.15.03,0,.07,0,.1,0,0-.04,0-.09,0-.13l-.02-.47c-.06-1.28-.12-2.6-.15-3.9,0-.16.12-.3.29-.31h0c.16,0,.29.11.3.27.13,1.26.26,2.65.41,4.36v.04s-.1.02-.1.02l.11.03v.02c.05.72.07,1.48-.21,2.25-.3.88-.94,1.46-1.73,1.58-.08,1.34,0,2.92.09,4.45.05.98.11,1.91.11,2.72.01.45.03.91.05,1.37.05,1.51.11,3.07.09,4.61,0,.09,0,.19,0,.28,0,.58,0,1.18-.29,1.78-.09.19-.28.31-.51.31h0Z"
                />
                <path
                  class="threeCls-13"
                  d="M636.07,636.99c-.23,0-.42-.12-.51-.32-.37-.94-.33-1.89-.29-2.82.02-.4.03-.82.01-1.23.04-1.85.14-4.29.22-6.45l.06-1.52c0-.39.02-.79.04-1.17.05-.91.09-1.86-.06-2.77,0,0,0,0,0,0-.37-.21-.63-.65-.82-.98l-.04-.06c-.31-.53-.56-1.14-.73-1.8-.18-.7-.28-1.45-.29-2.25,0-.61.02-1.4.36-2.08.14-.28.3-.48.49-.61.22-.15.47-.2.64-.23.17-.03.34-.04.52-.04.7,0,1.33.24,1.76.67.7.69.82,1.75.85,2.79.02.78.02,1.6-.18,2.4-.17.66-.72,1.81-1.52,2.21,0,0,0,.01,0,.02-.18,1.46-.08,3.36.03,5.2.06.99.11,1.92.11,2.74.01.45.03.91.05,1.36.05,1.51.11,3.07.09,4.62,0,.09,0,.19,0,.28,0,.58,0,1.18-.29,1.78-.09.19-.28.31-.51.31h0Z"
                />
              </g>
            </g>
            <path
              class="threeCls-5"
              d="M598.3,557.35l-.32-25.13,1.32-34.89,20.55-1.49,21.13,1.51,21-.31,21.01.88,20.98-1.08,21.03,1.54M697.4,579.11l1.04,80.7-2.41,27.72,2.5,27.72-2.66,26.85-2.03,49.25-50.96.15.15-13.19-.44-14.22v-8.89l-.67-13.93-4.44-.22-11.33.44-8.67.22-10,.22-8.7.07,1.07-34.16-1.62-35.12,1.08-35.12-.74-58.48M698.44,497.69l-1.59,38.38.27,21.27"
            />
            <polygon
              class="threeCls-11"
              points="608.99 512.29 611.25 512.29 611.25 509.89 613.65 509.89 613.65 507.63 611.25 507.63 611.25 505.22 608.99 505.22 608.99 507.63 606.59 507.63 606.59 509.89 608.99 509.89 608.99 512.29 608.99 512.29"
            />
          </g>
        </g>
      </svg>
    </div>
  );
}

export default SlideThree;
